import BigNumber from 'bignumber.js/bignumber'
import { ChainId } from 'bakery-swap-sdk'
import { MINTTOKEN } from '../../constants/bakery'

export const SUBTRACT_GAS_LIMIT = 100000

const ONE_MINUTE_IN_SECONDS = new BigNumber(60)
const ONE_HOUR_IN_SECONDS = ONE_MINUTE_IN_SECONDS.times(60)
const ONE_DAY_IN_SECONDS = ONE_HOUR_IN_SECONDS.times(24)
const ONE_YEAR_IN_SECONDS = ONE_DAY_IN_SECONDS.times(365)

export const INTEGERS = {
  ONE_MINUTE_IN_SECONDS,
  ONE_HOUR_IN_SECONDS,
  ONE_DAY_IN_SECONDS,
  ONE_YEAR_IN_SECONDS,
  ZERO: new BigNumber(0),
  ONE: new BigNumber(1),
  ONES_31: new BigNumber('4294967295'), // 2**32-1
  ONES_127: new BigNumber('340282366920938463463374607431768211455'), // 2**128-1
  ONES_255: new BigNumber('115792089237316195423570985008687907853269984665640564039457584007913129639935'), // 2**256-1
  INTEREST_RATE_BASE: new BigNumber('1e18')
}

export const deadAddress = '0x000000000000000000000000000000000000dead'

export const contractAddresses = {
  nbl: {
    [ChainId.BSC_TESTNET]: '0xa5c0401eeA5B5D0671D1e3c66c1e9e378b39b389',
    [ChainId.BSC_MAINNET]: '0xFAA0fC7B803919B091dBe5FF709b2dAbb61b93d9'
  },
  nblBnbBlp: {
    [ChainId.BSC_TESTNET]: '0xC03b9af89D6401617299Bfb424f2e6Ebb9F193A0',
    [ChainId.BSC_MAINNET]: '0x701cDecE4A6de95aEd38181e991BA6247dFbC3d8'
  },
  earnNblMaster: {
    [ChainId.BSC_TESTNET]: '0x34B531c7cc0FB67A112F1BB6160A0f80Bc2EE5E3',
    [ChainId.BSC_MAINNET]: '0x55617D5d80a9B82D550C97bA5b6AEd7c972d30F2'
  },
  kxa: {
    [ChainId.BSC_TESTNET]: '0xF9F85B28F01363bf27e7CdD8743a7F391cD17450',
    [ChainId.BSC_MAINNET]: '0x2223bF1D7c19EF7C06DAB88938EC7B85952cCd89'
  },
  kxaMaster: {
    [ChainId.BSC_TESTNET]: '0xdE2db1023e586cbA162E8A5ea5244C0938bdfd8d',
    [ChainId.BSC_MAINNET]: '0x7EE462A3f686ef72b8f5Ba54DfeEBB08f8A584E9'
  },
  kxaBnbBlp: {
    [ChainId.BSC_TESTNET]: '0xD3f90e7d225E91d567102e8b8524324A8E428128',
    [ChainId.BSC_MAINNET]: '0x7E70Ed6B98870CAb6F4810Befd6FF79cc5b83783'
  },
  moni: {
    [ChainId.BSC_TESTNET]: '0x829bfE81815F5E2946d56bD39F7bd99880024099',
    [ChainId.BSC_MAINNET]: '0x9573c88aE3e37508f87649f87c4dd5373C9F31e0'
  },
  moniMaster: {
    [ChainId.BSC_TESTNET]: '0xe8e3812B45840b0157eF9eBa4eD710F32e13C139',
    [ChainId.BSC_MAINNET]: '0x0cD483b37d9d25e58028989B0D8C73c71Af663A9'
  },
  moniBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x4a42Fcd7B8F890F362Fd744781BCC8bEa96A50f9',
    [ChainId.BSC_MAINNET]: '0x45591cb51e9A6894C83Ef8Afda05B6B0Cf53322a'
  },
  kmoNFT: {
    [ChainId.BSC_TESTNET]: '0xb6b346668eBf4006e6d18320101b6fBBced68c85',
    [ChainId.BSC_MAINNET]: '0xC33d69a337B796A9f0F7588169cd874C3987BDE9'
  },
  nt: {
    [ChainId.BSC_TESTNET]: '0xe1E2B7B3B4b943f30dD08545B6D604855bda90fc',
    [ChainId.BSC_MAINNET]: '0xfbcf80ed90856AF0d6d9655F746331763EfDb22c'
  },
  ntMaster: {
    [ChainId.BSC_TESTNET]: '0xC365532e25A9B5235bde99F6752f8BeC86a3575f',
    [ChainId.BSC_MAINNET]: '0x8FED5324DD180A72e7eD54e3CEf1A843aA89FC60'
  },
  ntBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x8c645997437dfA407d0d3645d1507B21A1E10d1a',
    [ChainId.BSC_MAINNET]: '0x66FF6Fb4e29AC162Cc159BC5527c61045883E3A9'
  },
  kTreasureAdvanced: {
    [ChainId.BSC_TESTNET]: '0x12a66Dd2d45579D76260ad063954966A56d9dC3C',
    [ChainId.BSC_MAINNET]: '0x646b31b5dBA095537eE5f101F57062338D3C2ed7' // 主网生产
  },
  kRabbit: {
    [ChainId.BSC_TESTNET]: '0x547e95855024E71Fc6b9DB8FdE078f188b9eA9FF',
    [ChainId.BSC_MAINNET]: '0x068E775B5F09B6d047E235694f15f9e3E9445A56' // 主网生产
  },
  don: {
    [ChainId.BSC_TESTNET]: '0x47e0daA2f9bFB5db86584f7220cA7cBadCF72068',
    [ChainId.BSC_MAINNET]: '0x86B3F23B6e90F5bbfac59b5b2661134Ef8Ffd255'
  },
  donMaster: {
    [ChainId.BSC_TESTNET]: '0x1c4c22F7522f1CccC4ef4f6eD51f30Efa0752004',
    [ChainId.BSC_MAINNET]: '0x05B199579d294F54Dea28f2151aDD222FDAfb104'
  },
  donBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x95FC98404D72e70D4bf2559F509aC467FE97BB2b',
    [ChainId.BSC_MAINNET]: '0xF4b9870548fcAd2ff4818C5D12cC2feAa840f0F0',
  },
  // don: {
  //   [ChainId.BSC_TESTNET]: '0x558439c050e24C4463acDecAB423B39ad79c2223',
  //   [ChainId.BSC_MAINNET]: '0x32299c93960bB583A43c2220Dc89152391A610c5'
  // },
  // donMaster: {
  //   [ChainId.BSC_TESTNET]: '0x7e405B95554a3A3DAe10BbA29B3114c4B13F9b3b',
  //   [ChainId.BSC_MAINNET]: '0x11333c997A420DC7638B5876dB53965751C93BDc'
  // },
  // donBnbBlp: {
  //   [ChainId.BSC_TESTNET]: '0xe605c6AEE60Be17f804D810fba65f2d25a9F9C9e',
  //   [ChainId.BSC_MAINNET]: '0x974497FfF51a4ee2F84F8a5372cFD0163702aA0d',
  // },
  kalata: {
    [ChainId.BSC_TESTNET]: '0x558439c050e24C4463acDecAB423B39ad79c2223',
    [ChainId.BSC_MAINNET]: '0x32299c93960bB583A43c2220Dc89152391A610c5'
  },
  kalataMaster: {
    [ChainId.BSC_TESTNET]: '0x7e405B95554a3A3DAe10BbA29B3114c4B13F9b3b',
    [ChainId.BSC_MAINNET]: '0x11333c997A420DC7638B5876dB53965751C93BDc'
  },
  kalataBnbBlp: {
    [ChainId.BSC_TESTNET]: '0xe605c6AEE60Be17f804D810fba65f2d25a9F9C9e',
    [ChainId.BSC_MAINNET]: '0x974497FfF51a4ee2F84F8a5372cFD0163702aA0d',
  },
  egg: {
    [ChainId.BSC_TESTNET]: '0xf944C0D39380eC3ED202eB0Bac0F24594b0aDC70',
    [ChainId.BSC_MAINNET]: '0x889eFCe29fa0BB9B26be9fda17A8003F4e8dA4dE'
  },
  eggMaster: {
    [ChainId.BSC_TESTNET]: '0xe3F816df01c631DA88f822A1B8b3cfc371443dab',
    [ChainId.BSC_MAINNET]: '0x167f49A57269Aa06267018C251bB5A777d9ACeb6'
  },
  eggBnbBlp: {
    [ChainId.BSC_TESTNET]: '0xe0718470631f805288Cf3485c00d89F356c29959',
    [ChainId.BSC_MAINNET]: '0xA3fB539deD45Adc9f2aa39c612cE2c65A8d0dBa2',
  },
  dogo: {
    [ChainId.BSC_TESTNET]: '0x555428e499c37eE2051b4C926e67901FEBd28329',
    [ChainId.BSC_MAINNET]: '0x9E6B3E35c8f563B45d864f9Ff697A144ad28A371'
  },
  dogoMaster: {
    [ChainId.BSC_TESTNET]: '0x88d78c6E9465799eA09dF3C87C3779599ad3519F',
    [ChainId.BSC_MAINNET]: '0x7874a3918f89e0329932636F1d2fdbee2059a2e5'
  },
  dogoBnbBlp: {
    [ChainId.BSC_TESTNET]: '0xED4Ce139a04bf95fb9E7C2af7E7cE8364b683b97',
    [ChainId.BSC_MAINNET]: '0x4b30B516D086fFa80A2fD4830604fC30EA7885A4',
  },
  bmoncNFT: {
    [ChainId.BSC_TESTNET]: '',
    [ChainId.BSC_MAINNET]: '0xACD21e605e838f1b5D2294f05f635250aF9BBbbb',
  },
  bmonc: {
    [ChainId.BSC_TESTNET]: '0xAb2a49E6D581998e9508F8b4aA21b9F2D9c92c32',
    [ChainId.BSC_MAINNET]: '0x39F742ba717F6203e081fBC0418FA60F1e245Ea1',
  },
  stakeBmoncEarnBmon: {
    [ChainId.BSC_TESTNET]: '0x4d3e584ac57D2e9E59BA254a5301c79275391805',
    [ChainId.BSC_MAINNET]: '0x922C79a5327630fD42F79367fd5Aae6BA605dF64',
  },
  bnrgBnbBlp: {
    [ChainId.BSC_TESTNET]: '0xE324c49fEc4F8C2bfd737e4D7a14D1190e8F92d2',
    [ChainId.BSC_MAINNET]: '0x84F8d5f4E41fC0596A7FD918f7D73df3ffa6dF5B',
  },
  bnrg: {
    [ChainId.BSC_TESTNET]: '0xc0eF3a309e35627997E8B5EfB9A5E2A394884091',
    [ChainId.BSC_MAINNET]: '0xd8813B5Dfa9AbEB693F217Bb905ec99B66FB017C',
  },
  bmon: {
    [ChainId.BSC_TESTNET]: '0x73916fe1b42A9c21dC66adef222Be2ceB1299Ebe',
    [ChainId.BSC_MAINNET]: '0x08ba0619b1e7A582E0BCe5BBE9843322C954C340',
  },
  bmonBnbBlp: {
    [ChainId.BSC_TESTNET]: '0xa2a2cDFa804a70192a3545AeB1785eaF9314678f',
    [ChainId.BSC_MAINNET]: '0x9194084158525BD645e6D83d59F5C3138e8e592B',
  },
  bmonBusdBlp: {
    [ChainId.BSC_TESTNET]: '0xC6e70a0941F6341eC64E5ABA8c84A01C8FA25F6F',
    [ChainId.BSC_MAINNET]: '0x7ADcd497eeA59A8B26e4f69e79f79b24dc2920c1',
  },
  earnBnrgMaster: {
    [ChainId.BSC_TESTNET]: '0x57f699796E7702590CEE0143345dd0D217bF6495',
    [ChainId.BSC_MAINNET]: '0x82B58aEa9Ee704bA3191D85decE3794400a4a100',
  },
  ga: {
    [ChainId.BSC_TESTNET]: '0x0aFf2C7A12630d6369513db89985E8922Ee37BDA',
    [ChainId.BSC_MAINNET]: '0xff473df96251AcFfb0Ae06fDAA51d33F1Dafff7c',
  },
  sellNFTs: {
    [ChainId.BSC_TESTNET]: '0xd88E2649AD4e6Fe55C9E00681547a24c2CEb05c7',
    [ChainId.BSC_MAINNET]: '0x2299C1be61d1fFAD49b324f5361255Ddb3C185Ef',
  },
  newDonghuangArt: {
    [ChainId.BSC_TESTNET]: '0x3cFE8101C04b55eB3E42D19F468bce982B96Dc45',
    [ChainId.BSC_MAINNET]: '0x3cFE8101C04b55eB3E42D19F468bce982B96Dc45',
  },
  carNFTCommonStakeERC721EarnBake3: {
    [ChainId.BSC_TESTNET]: '0x520Ef493919e759E0E9eB00389C63d9059E0A06c',
    [ChainId.BSC_MAINNET]: '0x63de4F5C93ae6563b6e7364076559615185e0cd4'
  },
  comboNFTCommonStakeERC721EarnBake3: {
    [ChainId.BSC_TESTNET]: '0x8f3A4fC20673E7e03A189B5d2E493F8212eC5a88',
    [ChainId.BSC_MAINNET]: '0x8a10668B08B842624D6ab088da2F9D2D20016128'
  },
  pokerCardCommonStakeERC721EarnBake3: {
    [ChainId.BSC_TESTNET]: '0x9148886045d55C5Ac3730Af0B47C12880A9f4EAe',
    [ChainId.BSC_MAINNET]: '0xe5386c34428b15A10863F7D94c664EF2CDf605Db'
  },
  bakeMuskMixerCommonStakeERC721EarnBake3: {
    [ChainId.BSC_TESTNET]: '0x119CC00704d463eb6810700dc1Ef1d323bE23861',
    [ChainId.BSC_MAINNET]: '0x7Eb0fa4969a333f6082d626B1f8DcF8F5400A359'
  },
  doggyEquipmentCommonStakeERC721EarnBake3: {
    [ChainId.BSC_TESTNET]: '0x7FEBBB68d6337Fb65dfba6255C65f439f490F8fa',
    [ChainId.BSC_MAINNET]: '0xefad326Ab053c41d64A5a46D1915ef0967378FAC'
  },
  barkingNFTCommonStakeERC721EarnBake3: {
    [ChainId.BSC_TESTNET]: '0x88E48FBeaE050668d4fADf320Ad1f0C737965fa9',
    [ChainId.BSC_MAINNET]: '0xCF69897767552437cA166DD1A1AC4DA8eBe66B4e'
  },
  doggyNFTCommonStakeERC721EarnBake3: {
    [ChainId.BSC_TESTNET]: '0xC0d20acCF486485B632F710cae723972cA63A164',
    [ChainId.BSC_MAINNET]: '0x99cc4EC3a73B7191e5Ad50811DE3fF408D91B98D'
  },
  bakerySoccerCommonStakeERC721EarnBake3: {
    [ChainId.BSC_TESTNET]: '0x299f6A4A285e62672686A789EBDc9baE129B17c7',
    [ChainId.BSC_MAINNET]: '0xb50c494447c37F83E00D964291c644abeF4dc643'
  },
  muskUsmLand: {
    [ChainId.BSC_TESTNET]: '0x61Ccf7a0352C5c07d6bd81Ab128A2Ed8AAB6E091',
    [ChainId.BSC_MAINNET]: '0xb5665e1038c4E17C58aB55b5C591faB52CE83fC4'
  },
  exchangeNFTs2: {
    [ChainId.BSC_TESTNET]: '0x45C95df8f8e0F6ff7eFc3a2F63971fB75492C607',
    [ChainId.BSC_MAINNET]: '0x047c5ED6374BD9c73e6e1779d6769a967Bb5c898'
  },
  carNFTCommonStakeERC721EarnBake2: {
    [ChainId.BSC_TESTNET]: '0x95Ee9f566A40FC2419B9cC2caFD89c9c9EFDA503',
    [ChainId.BSC_MAINNET]: '0x41971ef277d97F7b793a8875481a077573DB85ec'
  },
  comboNFTCommonStakeERC721EarnBake2: {
    [ChainId.BSC_TESTNET]: '0x4D4fbF44F8db31A277D16430B7601dA5911948e2',
    [ChainId.BSC_MAINNET]: '0xEc61F09042002306ae4Df6C41de56BeEefa97C2a'
  },
  pokerCardCommonStakeERC721EarnBake2: {
    [ChainId.BSC_TESTNET]: '0xE7dDC412F226FDAF379F119334ce1f31C4AFD609',
    [ChainId.BSC_MAINNET]: '0x1AF8b90987294aa71DA08Af9E2FDFfE6841006ce'
  },
  bakeMuskMixerCommonStakeERC721EarnBake2: {
    [ChainId.BSC_TESTNET]: '0xB3561Dd2eeBc78E4C82B701aeE78400F5a9dcBa6',
    [ChainId.BSC_MAINNET]: '0x9cdDE8B52F4A85F68e33BEFEE83c6Bb83d2A4067'
  },
  doggyEquipmentCommonStakeERC721EarnBake2: {
    [ChainId.BSC_TESTNET]: '0x2a39264488095Aa2c8196fA5d753C5b52AAB8544',
    [ChainId.BSC_MAINNET]: '0xeE659249dd324423b1BFA8bf457ae4d9b57A5f8c'
  },
  barkingNFTCommonStakeERC721EarnBake2: {
    [ChainId.BSC_TESTNET]: '0x6aea9F4dFd1e5e96d8AC914EdE09ED50f4F2aFd1',
    [ChainId.BSC_MAINNET]: '0x603331bB915eE843b5328E558EaEcBb56a873cef'
  },
  doggyNFTCommonStakeERC721EarnBake2: {
    [ChainId.BSC_TESTNET]: '0xB6E2b1ea5b095e126B9fb19ea104763dca3111Cc',
    [ChainId.BSC_MAINNET]: '0x09C7C32684a7C2a010a10552cB4467Bbced04720'
  },
  bakerySoccerCommonStakeERC721EarnBake2: {
    [ChainId.BSC_TESTNET]: '0xdce54e2AA153699968553b1f856c029a74EC4Ac6',
    [ChainId.BSC_MAINNET]: '0x4726C7E5C7eA619929aAcF0e7Efd0dA459280916'
  },
  bakeBusdBlp: {
    [ChainId.BSC_TESTNET]: '0xF5BE5d0e9d43280408f3C8d3Cc5e2F4D55C1887E',
    [ChainId.BSC_MAINNET]: '0x6E218EA042BeF40a8baF706b00d0f0A7b4fCE50a'
  },
  busdBnbBlp: {
    [ChainId.BSC_TESTNET]: '0xAf5e8AA68dd1b61376aC4F6fa4D06A5A4AB6cafD',
    [ChainId.BSC_MAINNET]: '0x559e3D9611E9cB8a77c11335Bdac49621382188B'
  },
  usdtBnbBlp: {
    [ChainId.BSC_TESTNET]: '0xa38661A1Aa00ab39ACD6f276Ed6a21C90A83Ae6b',
    [ChainId.BSC_MAINNET]: '0x9Ec271C041a18aA7beF070A1F196eea1D06Ab7cb'
  },
  masterChef2: {
    [ChainId.BSC_TESTNET]: '0x61d777dC41Bb391c491a644974C18fC069Ad3e62',
    [ChainId.BSC_MAINNET]: '0x6a8DbBfbB5a57d07D14E63E757FB80B4a7494f81'
  },
  bakeMuskMixer: {
    [ChainId.BSC_TESTNET]: '0xd1B12D0DbeF4e725A59381F68ceA83014CdEf80b',
    [ChainId.BSC_MAINNET]: '0x6EFdD0380C9DdE9c50ae99669d8FFd9439EFCDBd'
  },
  bakeMuskMixerCommonStakeERC721EarnBake: {
    [ChainId.BSC_TESTNET]: '0xAD857Fe79337e1C2A095a056036e80498684A35C',
    [ChainId.BSC_MAINNET]: '0xF6Dae27Ac841A4A66a631149cDD8c22cD0eCE510'
  },
  toysCommonNftMaster: {
    [ChainId.BSC_TESTNET]: '0xaEf2894E66683612f00BB769e327532164483Aec',
    [ChainId.BSC_MAINNET]: '0xd775FbBEED084Dd7848f5be8900a601082DF603e'
  },
  bethEthBlp: {
    [ChainId.BSC_TESTNET]: '0x07b5a883c74a844232533ee8b713f5210fe15b5b',
    [ChainId.BSC_MAINNET]: '0xFb72D7C0f1643c96c197A98E5f36eBcf7597d0E3'
  },
  bethMaster: {
    [ChainId.BSC_TESTNET]: '0xfA3FF30B99025eEE384c34FC6A24ae69c2B3dfe0',
    [ChainId.BSC_MAINNET]: '0xE985C3c78f617a793FB844d80CDC22104aCf6370'
  },
  ktaNFT: {
    [ChainId.BSC_TESTNET]: '0x20538747cFf2beC826D14546b46A4AbaA8a77dca',
    [ChainId.BSC_MAINNET]: '0x3565AC59Aa2127D4C45bd050b673fBe6202cd742'
  },
  tokauMaster: {
    [ChainId.BSC_TESTNET]: '0x69c3D8B9B532c85d36fF80e12Cbf9D064c84a340',
    [ChainId.BSC_MAINNET]: '0x339b39341e8F8252f679504f1b0a83B8E8750B3F'
  },
  wsg: {
    [ChainId.BSC_TESTNET]: '0x3A1d30E626D9A9a8c2D556c0d985dbC2C76D8273',
    [ChainId.BSC_MAINNET]: '0xA58950F05FeA2277d2608748412bf9F802eA4901'
  },
  wsgBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x3198686E28dB517db7A10D8311d709A0155942dF',
    [ChainId.BSC_MAINNET]: '0x799C768e66dfFBb8BDf8de8fd7ECD4B49fE90d93'
  },
  wsgMaster: {
    [ChainId.BSC_TESTNET]: '0x440220B1cc00F8B24378be08cA4c1f5Ff3e92279',
    [ChainId.BSC_MAINNET]: '0xd4E4d73201ACf2D2F9CE5EB13A5752F4a16aFDEB'
  },
  gatBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x33e27Cd0b77EF9a8943400e40141cAA1a117925d',
    [ChainId.BSC_MAINNET]: '0xAD19E7D581b6f252AFA5aAE3c6C8dC3680A475c3'
  },
  gatBakeBaseIDO: {
    [ChainId.BSC_TESTNET]: '0xF57feBB1C8F46d7176342BB86Be596Dc8af53AEF',
    [ChainId.BSC_MAINNET]: '0xB56F47E840beED958EA888ECA7E6ddfda7b89A27'
  },
  gatTlmMaster: {
    [ChainId.BSC_TESTNET]: '0x233c70Fa25c0496D8C2D86430DF5C5A9F7AF0601',
    [ChainId.BSC_MAINNET]: '0xFeFC9036a4867c29dea1800187d0F54317E890F5'
  },
  lev: {
    [ChainId.BSC_TESTNET]: '0x75C507a3eACaFd95867617F0520BcB1CDAa026e0',
    [ChainId.BSC_MAINNET]: '0x304c62b5B030176F8d328d3A01FEaB632FC929BA'
  },
  siBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x32c0e145Def3c733499323527D315fFb42990Ddd',
    [ChainId.BSC_MAINNET]: '0x793Bd2A45A63e140b68D0Bc36660baFFC6453379'
  },
  liBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x604F7d01599fB19e2dD0F58c07F4C8343B70067d',
    [ChainId.BSC_MAINNET]: '0xe87FEe5eb4DE4C6b437d19A795b8c4ec81d3B250'
  },
  levBnbBlp: {
    [ChainId.BSC_TESTNET]: '0xEf95237777a4868da47f7627A354F7054fD454E7',
    [ChainId.BSC_MAINNET]: '0xf6e8Df456e114050a2eb813221e547a5F448890D'
  },
  levMaster: {
    [ChainId.BSC_TESTNET]: '0x0327AcB6156f09f2a9b5Ae3E83FCDA7a0c795b38',
    [ChainId.BSC_MAINNET]: '0x93b37B56d8a48815a2520E3E8d0a782EC7452755'
  },
  toys: {
    [ChainId.BSC_TESTNET]: '0xdc69358B373722AD04A68D37704CfAa055d2a277',
    [ChainId.BSC_MAINNET]: '0x14a62860de2Fdec247D48780ed110DBB794545d8'
  },
  gat: {
    [ChainId.BSC_TESTNET]: '0xF704f2167FEBB80eDED86b92c9287119cE20ea95',
    [ChainId.BSC_MAINNET]: '0xF315cfC8550F6FcA969D397cA8b807C5033fA122'
  },
  simpleStakeToysEarnGat: {
    [ChainId.BSC_TESTNET]: '0x734e9CEB2fb0cff3B18c595E9d54FaB18D5eF3f0',
    [ChainId.BSC_MAINNET]: '0x735c9F9e03011a04c537fe7b4E839317eF64cf03'
  },
  doggyEquipmentCommonStakeERC721EarnBake: {
    [ChainId.BSC_TESTNET]: '0x749C5097219d520752f3060eFa6cD2c3ed6ca235',
    [ChainId.BSC_MAINNET]: '0xb6f8afbB1C23e7036f3A78690064a128F4396710'
  },
  doggyEquipment: {
    [ChainId.BSC_TESTNET]: '0x043E2Dd8C1059637B10131c01CD294A5d2C0fbdE',
    [ChainId.BSC_MAINNET]: '0x15C7160F82DEF33AF05B7348843f3Ad647b4d012'
  },
  matrixPlusBox: {
    [ChainId.BSC_TESTNET]: '0x5EFea7B6D6EfD0400354185fEB9B3fe7BDF0fA76',
    [ChainId.BSC_MAINNET]: '0x061C6eECA7B14cF4eC1B190Dd879008DD7d7E470'
  },
  matrixPlusBoxCommonStakeERC721EarnBake: {
    [ChainId.BSC_TESTNET]: '0xeade079Bd8A8Ea04aF469607d3B0776E9f4Dfdd3',
    [ChainId.BSC_MAINNET]: '0xeade079Bd8A8Ea04aF469607d3B0776E9f4Dfdd3' // NOT TO DO
  },
  tokauNFT: {
    [ChainId.BSC_TESTNET]: '0xaa477076A0CEB64E2f0302a82857fDb819C67996',
    [ChainId.BSC_MAINNET]: '0x4E64198C1E13248BfC0e63D53E03460dbB383a94'
  },
  doge: {
    [ChainId.BSC_TESTNET]: '0x7C4234Af027a1E3B8Fc29d2cBbA014bDfEbA534F',
    [ChainId.BSC_MAINNET]: '0xbA2aE424d960c26247Dd6c32edC70B295c744C43'
  },
  exchangeNFTs: {
    [ChainId.BSC_TESTNET]: '0x02730b54fCa5Aca6eD592414D9Bf84Ab49fcc537',
    [ChainId.BSC_MAINNET]: '0x5cd94411FE83f81B639bee44BbB4C9F3bfF218eF'
  },
  xmsBakeBaseIDO: {
    [ChainId.BSC_TESTNET]: '0xAb141A83836F69F979B5C7a34564502dD1805b3d',
    [ChainId.BSC_MAINNET]: '0xB535D44D16e7cDEf51D568539e8DA80CF4a0B6a1'
  },
  bscBakeNFT: {
    [ChainId.BSC_TESTNET]: '0x8d7e88Fb05E2991Ee89d01A4c4ec980F41956cc3',
    [ChainId.BSC_MAINNET]: '0x43DB8ea81074b31Cf2665B600A4086cF36B59445'
  },
  exchangeBscBakeNFT: {
    [ChainId.BSC_TESTNET]: '0xBa14dc377fcED2e20BfC39f2581295503f7088B7',
    [ChainId.BSC_MAINNET]: '0xf10970552A9B60AFbfF90d97E5DCAf7565e4700c'
  },
  bidBscBakeNFT: {
    [ChainId.BSC_TESTNET]: '0x92fE5e3c1eD8E9636a405eBb2CB2aE814c409686',
    [ChainId.BSC_MAINNET]: '0xC32EA351FEEfF02F422EEF11794fe9D640Ad28Fb'
  },
  tokau: {
    [ChainId.BSC_TESTNET]: '0x58AF5256EdB2628a181ce8e7A2E01510401E9209',
    [ChainId.BSC_MAINNET]: '0xC409eC8a33f31437Ed753C82EEd3c5F16d6D7e22'
  },
  tokauBnbBlp: {
    [ChainId.BSC_TESTNET]: '0xD9cA785D9db4719a773a83D1e4dd4e2de2065014',
    [ChainId.BSC_MAINNET]: '0xa9F65a288aB4c4FaE59192D3867B5C27136A12a4'
  },
  tokauTlmBlp: {
    [ChainId.BSC_TESTNET]: '0xCD382C7711B8F799245664aB18cc34f6c0f8Fe9E',
    [ChainId.BSC_MAINNET]: '0xF1f44174b6FCB4cC87095Bd46637c69Ca74a8240'
  },
  tokauTlmMaster: {
    [ChainId.BSC_TESTNET]: '0x7767b5BB71BF8E6c94fd3EfAca75286798Be7762',
    [ChainId.BSC_MAINNET]: '0x49A47FFA2d780ed3B737d217040Cb6ea6e673e2a'
  },
  tokauBakeBaseIDO: {
    [ChainId.BSC_TESTNET]: '0xdb0A198A96d770aD37E612e840141584b82E004B',
    [ChainId.BSC_MAINNET]: '0x792Cc1257faD723203d12E94Af43Fc6b6D6d27e2'
  },
  bark: {
    [ChainId.BSC_TESTNET]: '0xb1528a7BE5A96B77de5337988Ba69029cA6E2c7A',
    [ChainId.BSC_MAINNET]: '0xb1528a7BE5A96B77de5337988Ba69029cA6E2c7A'
  },
  barkingNFT: {
    [ChainId.BSC_TESTNET]: '0x2042629F09193ef0e84Ce38f80d82d715E67378F',
    [ChainId.BSC_MAINNET]: '0xa86Bd7C13C19CC4586dcb07CF06Fa1f9578a6212'
  },
  barkingNFTCommonStakeERC721EarnBake: {
    [ChainId.BSC_TESTNET]: '0x0bb475670cC9102A90715acb96fa01D595B5Cdab',
    [ChainId.BSC_MAINNET]: '0x4120Ee3D4749Ef92F6643DC63a1fbA49642ce568'
  },
  exchangeBarkingNFT: {
    [ChainId.BSC_TESTNET]: '0xEe5B7e93F23F6b77a9285158DBffb87D3766aBb7',
    [ChainId.BSC_MAINNET]: '0x0387d77EAAa60Ca24E91371d9107337Dd3b4a866'
  },
  bidBarkingNFT: {
    [ChainId.BSC_TESTNET]: '0xec4E345E8CB5D99070589430A94A1577fc0A087c',
    [ChainId.BSC_MAINNET]: '0x0cD070E69B74Bd3E3B2409d190E0223e1b0f9fE7'
  },
  barkDoggyBLp: {
    [ChainId.BSC_TESTNET]: '0x27Cb9353FE2E990Ad3d2211dDe677dc9D199A6B4',
    [ChainId.BSC_MAINNET]: '0x39D0Af32f4f5A4A0E462f5f2c91414859cB933F9'
  },
  barkBnbBLp: {
    [ChainId.BSC_TESTNET]: '0xf20A56737E0a0750652C99C9C805c23B3bDC0F7c',
    [ChainId.BSC_MAINNET]: '0x29124591D1169F8712c5D944d8b2b9385f28FEeC'
  },
  barkTlmMaster: {
    [ChainId.BSC_TESTNET]: '0x2fD04d424528b4c7752939bC073329010dDEe962',
    [ChainId.BSC_MAINNET]: '0xbB4B43FFe5d5990e6C8BEF1EE3997Bd176Dfd002'
  },
  mintAddress: {
    [ChainId.BSC_TESTNET]: [
      '0xB71aF922E332eb7ef6adcabd3cC142bcEFdE7BD9',
      '0x8935dF9aa4856205526955159ffCa12DfB4EBb7f',
      '0xde5fE38A6990AeB44eb21c9624648e4893B170C9',
      '0x83B69ab825d3dd803ECc868198A08A8170eF97D4',
      '0xc99e4E934f1dDd2E3E03FfE38Fe862aB5d6139BE',
      '0x05c8c6392380F9613B234B5e3edaAcb54A483ec5'
    ],
    [ChainId.BSC_MAINNET]: [
      '0xB71aF922E332eb7ef6adcabd3cC142bcEFdE7BD9',
      '0x8935dF9aa4856205526955159ffCa12DfB4EBb7f',
      '0xde5fE38A6990AeB44eb21c9624648e4893B170C9',
      '0x83B69ab825d3dd803ECc868198A08A8170eF97D4',
      '0xc99e4E934f1dDd2E3E03FfE38Fe862aB5d6139BE',
      '0x05c8c6392380F9613B234B5e3edaAcb54A483ec5',
      '0xB23aEAB7DB94453E37C171ca85bd4633f77A085C'
    ]
  },
  raca: {
    [ChainId.BSC_TESTNET]: '0x17D6ab3996fb900e426b52Ed2f9c41383B60B84a',
    [ChainId.BSC_MAINNET]: '0x043b49749e0016e965600d502e2177ca2d95b3d9'
  },
  racaNFT: {
    [ChainId.BSC_TESTNET]: '0x56eE34f363B392f892e40CeE0bDCdAB304c3267a',
    [ChainId.BSC_MAINNET]: '0x7f7B196A82Eb555D20DeA60a64d2D910EbFe9cf9'
  },
  exchangeRacaNFT: {
    [ChainId.BSC_TESTNET]: '0xd93d77EBeFa2e3Cb9236A6ca184F0c1fc14631e3',
    [ChainId.BSC_MAINNET]: '0x05b39c7F648F51153c65C770220bbA001dac8a38'
  },
  bidRacaNFT: {
    [ChainId.BSC_TESTNET]: '0x6e6F567E740a372A693A5798ac3e8ED5E1fad0C1',
    [ChainId.BSC_MAINNET]: '0x01fA298fA3A507048D16DC6669a4ba22FD9f0e55'
  },
  ginu: {
    [ChainId.BSC_TESTNET]: '0x6153B286e288d2AC7D9C62E93a6f2864044F3DaC',
    [ChainId.BSC_MAINNET]: '0x6702e449243e5b8c59ceb29a4772e6d1d9fa7727'
  },
  ginuBnbBLp: {
    [ChainId.BSC_TESTNET]: '0x6820140d1084C18Ba560031C3209616e834C08Fb',
    [ChainId.BSC_MAINNET]: '0x15461F6B3898F3Bf2caFf6fF679f18CFdD97e414'
  },
  ginuMaster: {
    [ChainId.BSC_TESTNET]: '0xD053C66191c5596B9497E77A2f91fd360fdD064E',
    [ChainId.BSC_MAINNET]: '0xca5fB7170A9778cb9c788065D340fFE9A43F1cCF'
  },
  loveNFT: {
    [ChainId.BSC_TESTNET]: '0x66944225b69E3F5Dc075D0D01950746024db597B',
    [ChainId.BSC_MAINNET]: '0x6475270a858E0056e5aFc9187C87507B01375890'
  },
  exchangeLoveNFT: {
    [ChainId.BSC_TESTNET]: '0x2946a61ABa48140b1DAfAfe030329B64BbA06844',
    [ChainId.BSC_MAINNET]: '0xC546014189Cd734e475F2Eb5BbE67eaf81B2Cf11'
  },
  bidLoveNFT: {
    [ChainId.BSC_TESTNET]: '0x805A79453EB4a7d4f5fF19D2FAe71e0049AeDa45',
    [ChainId.BSC_MAINNET]: '0x585Fd9D48ae08152bEb0f001781Cd20CA30184D4'
  },
  bondly: {
    [ChainId.BSC_TESTNET]: '0x5567fB2AD2fA163e2301F466f0220d767030B064',
    [ChainId.BSC_MAINNET]: '0x96058f8C3e16576D9BD68766f3836d9A33158f89'
  },
  bondlyBnbBLp: {
    [ChainId.BSC_TESTNET]: '0x8a953823247473C582F2ea935908E02bd326201f',
    [ChainId.BSC_MAINNET]: '0x56c6c72193F26014CDa330DC7463bdF45C1b7A70'
  },
  bondlyMaster: {
    [ChainId.BSC_TESTNET]: '0x19a9c97114F3140318C5e3B6aC1a46BED3ea73F5',
    [ChainId.BSC_MAINNET]: '0x9EE90876ea8413bFDC1aBE90e3b140d6aaeb1524'
  },
  bondlyNft: {
    [ChainId.BSC_TESTNET]: '0x4ba782b05c7D580Ab6B896c6A63B8E5de53738B3',
    [ChainId.BSC_MAINNET]: '0x4ba782b05c7D580Ab6B896c6A63B8E5de53738B3'
  },
  bondlyCommonNftMaster: {
    [ChainId.BSC_TESTNET]: '0xfa4F1d0f4C665323e83f27F91B11FA40f85ed3E0',
    [ChainId.BSC_MAINNET]: '0x2D14af7806c9B76927E5d899881b46057a1a1c52'
  },
  exchangeBondlyNFT: {
    [ChainId.BSC_TESTNET]: '0x6ad21892AC395D1f6AD97E1391Fc96D4499082f9',
    [ChainId.BSC_MAINNET]: '0x1f48ae3BCB24dDda1E2F5Eea03B0c774EB3681c2'
  },
  bidBondlyNFT: {
    [ChainId.BSC_TESTNET]: '0x2b55758F11b3CB56201B4A09EB9e52ef91cDAf39',
    [ChainId.BSC_MAINNET]: '0xEBEad42e26BD602B668135E329657239b866733a'
  },
  doggyBondlyMaster: {
    [ChainId.BSC_TESTNET]: '0x755718e2a87ceaFc945F04959682ee34bFd29bb8',
    [ChainId.BSC_MAINNET]: '0x133E831AcaEC70675291334C326e949F10AAA615'
  },
  doggy: {
    [ChainId.BSC_TESTNET]: '0x1f79374402b770ced370cea67124000b2b5ef54f',
    [ChainId.BSC_MAINNET]: '0x74926B3d118a63F6958922d3DC05eB9C6E6E00c6'
  },
  doggyNFT: {
    [ChainId.BSC_TESTNET]: '0xFc2198e0d4e6a5e65738C1f9E55F5A02c03B36cc',
    [ChainId.BSC_MAINNET]: '0x2DcA8804DCA120085E9b511F18D8511F58FaA64C'
  },
  doggyNFTCommonStakeERC721EarnBake: {
    [ChainId.BSC_TESTNET]: '0xa8861b47DF63259f229bc0e72659DF0DF521F8ac',
    [ChainId.BSC_MAINNET]: '0xc137699f44F868f904d41Db999d754Ed2c135F51'
  },
  doggyBnbBlp: {
    [ChainId.BSC_TESTNET]: '0xF583DcEb3F38760440F218369449DF7b9A3C1898',
    [ChainId.BSC_MAINNET]: '0x15301fD2e1D234fdfc7f5E28a6546F0668ea0f9b'
  },
  doggyBakeBaseIDO: {
    [ChainId.BSC_TESTNET]: '0x6B5F355E273B4b6887aE047eA3C8D27D10df0Fc6',
    [ChainId.BSC_MAINNET]: '0xD596759BC0Ab37814D0Ffa156d3573dFa12FC632'
  },
  doggyTlmMaster: {
    [ChainId.BSC_TESTNET]: '0xaee4c631d839aB5267fe2D44504b1b76dA7fE4E8',
    [ChainId.BSC_MAINNET]: '0xE3677Db1767E67c45052edF16D665D3C5263abdf'
  },
  exchangeDoggyNFT: {
    [ChainId.BSC_TESTNET]: '0xf12f1f44c2365a11aa278521ff66829Ad076EE91',
    [ChainId.BSC_MAINNET]: '0x9a76f57CFB92435e7031654AC89892777e68fF6b'
  },
  bidDoggyNFT: {
    [ChainId.BSC_TESTNET]: '0x1E244B034B75aCa63BD0cA59F118783CF07c4209',
    [ChainId.BSC_MAINNET]: '0x1f26880843297A3D55E6B9A24d75bcBF09681cbd'
  },
  exchangeCarNFT: {
    [ChainId.BSC_TESTNET]: '0xbc217809c585E480601e02cFC47a5eE7cBBb1EBF',
    [ChainId.BSC_MAINNET]: '0x615C0067Bed4A1B2421aB3c3898CDb4A9Ac13490'
  },
  bidCarNFT: {
    [ChainId.BSC_TESTNET]: '0xfe6d30b0c5a0a818135f395579e2dcb0d79c31f2',
    [ChainId.BSC_MAINNET]: '0x1927203b5E516D40864F55474F6F3431FAB442af'
  },
  carBakeBaseIDO: {
    [ChainId.BSC_TESTNET]: '0xdC8a38d45F798351dd9C814a820D64BBF5a2aD89',
    [ChainId.BSC_MAINNET]: '0x33760118f4AbA5c4Ff48A8d656E35F2EEa819059'
  },
  carNFT: {
    [ChainId.BSC_TESTNET]: '0x272eAF0FbF902C1d83ce41555a76159f6bc1DCBD',
    [ChainId.BSC_MAINNET]: '0x1D09fC4B295a2fa6F0E2E64a345BAE419EB04699'
  },
  carNFTStakingPowerToken: {
    [ChainId.BSC_TESTNET]: '0xCAecF68C7Cf90d738fC7A9E7e44854d3599C918D',
    [ChainId.BSC_MAINNET]: '0xA0e90bDABb28908c9d9419e58C658F20E60ba3aa'
  },
  carNFTMaster: {
    [ChainId.BSC_TESTNET]: '0x932b36134d100f62996b79E04126D2a983bDFf02',
    [ChainId.BSC_MAINNET]: '0xf99ee066B486F5Bc9f6f5c8D94629916710Ea422'
  },
  carBlindBox: {
    [ChainId.BSC_TESTNET]: '0x88Ce87A3A59A7aDFEA70b684255fBE12644e0F11',
    // [ChainId.BSC_MAINNET]: '0x74Db53381015ac19301eEbdBD17E719655e32e40'
    [ChainId.BSC_MAINNET]: '0x0628cfc88518CcEe96ef7bdFED8b4Ac8708cAd88'
  },
  car: {
    [ChainId.BSC_TESTNET]: '0xA942C0A2D901C74ea2382cdD6B82acD771494130',
    [ChainId.BSC_MAINNET]: '0x176a25637e5078519230A4d80A7A47350940264a'
  },
  carBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x930896E4a144A6a0dB7A0046666b84079E52510e',
    [ChainId.BSC_MAINNET]: '0xcB34F5F3fFBA8c550c7324d4fa3272E3922CaB4e'
  },
  yooshiNFT: {
    [ChainId.BSC_TESTNET]: '0x8361E869EAB932c65F89A7B9841ea0Bc77f00647',
    [ChainId.BSC_MAINNET]: '0x32afc8dC2Ff4AF284FA5341954050f917357A5f1'
  },
  exchangeYooshiNFT: {
    [ChainId.BSC_TESTNET]: '0x7E86eFC5Cbc69Ba82F0A982BF992209730542963',
    [ChainId.BSC_MAINNET]: '0xf13015E5aB82C20fB0E6083d89Dd1fD773badfF1'
  },
  bidYooshiNFT: {
    [ChainId.BSC_TESTNET]: '0x1bf574D2a5689BE35f39c400e98E879474b8fB7C',
    [ChainId.BSC_MAINNET]: '0x055930E510a331c448ce92D2A85F984ABa177fbb'
  },
  tlmBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x3bFc26Dc34FC67d2BB6e77850b52F58a3A274e0b',
    [ChainId.BSC_MAINNET]: '0x0D1C34C4AAA29CC9315b473aC8384DCE3B7C923A'
  },
  aliceBnbBlp: {
    [ChainId.BSC_TESTNET]: '0xDBD09Aa74c5a74Bc567D1F88DdA6B9407Eed5747',
    [ChainId.BSC_MAINNET]: '0x7Dc46c32D9C72DCf190269f127E03ED8c967d87F'
  },
  soccerPokerGameBox: {
    [ChainId.BSC_TESTNET]: '0x3D1C3E51c28b7AEF2c36ae7a207b4A5Ce322051D',
    [ChainId.BSC_MAINNET]: '0xe6a038119BEfe6c5FfBC8C030267a36D7B7297cf'
  },
  soccerPokerGameBoxBurnByProxy: {
    [ChainId.BSC_TESTNET]: '0x1C5fE692AECEe220d99e2a37de438BfE1aEAaF0c',
    [ChainId.BSC_MAINNET]: '0xC3d0861DB4e912F1280993e6eCffFffF646De527'
  },
  soccerPokerGameBoxMaster: {
    [ChainId.BSC_TESTNET]: '0xe64b1f10dE62787337415387c30A04A87Db3A93C',
    [ChainId.BSC_MAINNET]: '0xa0C4C14E6892CE93B9cbD998EAaE9b4faAC4B98B'
  },
  sfp: {
    [ChainId.BSC_TESTNET]: '0x5e9683194Fd412cA7B8a542560bECcA8210C3667',
    [ChainId.BSC_MAINNET]: '0xd41fdb03ba84762dd66a0af1a6c8540ff1ba5dfb'
  },
  sfpNFT: {
    [ChainId.BSC_TESTNET]: '0xAB727a87Df213f060831CeD12b64a5397fC0a88C',
    [ChainId.BSC_MAINNET]: '0x1d0E5AF3faee43B5cFFf8f872F41d43B93ed964B'
  },
  exchangeSfpNFT: {
    [ChainId.BSC_TESTNET]: '0xF0f09aDEB4BcbD3bCE20d90A8813b88B4566A71A',
    [ChainId.BSC_MAINNET]: '0xE590D8d25C525581Dc41ccCc3EBfefeCb7e74B56'
  },
  bidSfpNFT: {
    [ChainId.BSC_TESTNET]: '0x13F8D7B0FF58C85E1bb7D8C4427169D83cc3a9Bb',
    [ChainId.BSC_MAINNET]: '0x35996Ad8844407F9Ddd5D3deC8238F703364306f'
  },
  pokerCard: {
    [ChainId.BSC_TESTNET]: '0x95e81fc8cD65A95DB14DD55e22ab571134E86b8E',
    [ChainId.BSC_MAINNET]: '0xaDb0Ae1cb9cD289271D8D1f7a9757A2997CF940d'
  },
  pokerCardStakingPowerToken: {
    [ChainId.BSC_TESTNET]: '0xE5D53046b53697bB4870d1808D2837E382f37247',
    [ChainId.BSC_MAINNET]: '0x56c31FF91235a02a956c60dAf421a6Ab9e78688f'
  },
  pokerCardMaster: {
    [ChainId.BSC_TESTNET]: '0xd2Cfc08fF0B1e4cF612F4Fb599C934Ee2e7846b0',
    [ChainId.BSC_MAINNET]: '0x3c5F9CAfc50F0c6d0b539D5146eE0E63dBFCA643'
  },
  pokerBlindBox: {
    [ChainId.BSC_TESTNET]: '0x87c93dAB4BE9b60A6bACF7dB60cA1d3B625201B1',
    [ChainId.BSC_MAINNET]: '0xbca44A6685F42a2c7f2d0ae1aeA839ae38C509Aa'
  },
  poker: {
    [ChainId.BSC_TESTNET]: '0x4d4e595d643dc61EA7FCbF12e4b1AAA39f9975B8',
    [ChainId.BSC_MAINNET]: '0x82caA54eC9aAF213FF611aF63d4B650ACcFF53ae'
  },
  pokerBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x21fCEB6B694949F8abfAc84BE855daF641931e00',
    [ChainId.BSC_MAINNET]: '0x5a8e5f77a2922395ADCdf54ce8c0593882bD0Cfc'
  },
  pokerBakeBaseIDO: {
    [ChainId.BSC_TESTNET]: '0x2c6879CEdca6747dfa16061ADD08e8BC4bD43613',
    [ChainId.BSC_MAINNET]: '0x166Cb815Ba64D1A0Bae17E678A2924CdE476E11A'
  },
  dittoNft: {
    [ChainId.BSC_TESTNET]: '0xE3CD6A046698B627d0fc1999c8065712e1ceCf41',
    [ChainId.BSC_MAINNET]: '0xE3CD6A046698B627d0fc1999c8065712e1ceCf41'
  },
  dittoCommonNftMaster: {
    [ChainId.BSC_TESTNET]: '0x35dbB1A7236e1B0F29a2179DB2503De02E2529Bb',
    [ChainId.BSC_MAINNET]: '0x57B702a4191625e076f72a95F95213d30f4662e1'
  },
  tsa: {
    [ChainId.BSC_TESTNET]: '0x4e417f9B68260ff45B6BeF08872114c2fa9d1C81',
    [ChainId.BSC_MAINNET]: '0x5f99ACF13CAff815DD9cB4A415c0fB34e9F4545b'
  },
  tsaMaster: {
    [ChainId.BSC_TESTNET]: '0x1d9f98136Ca3B489c703A59C094Be9e25C09be03',
    [ChainId.BSC_MAINNET]: '0xcE06442424E8DE15E55b379ABdE8E01ca696f4C9'
  },
  tsaBakeBlp: {
    [ChainId.BSC_TESTNET]: '0xef61F561C80094FcE3a4AEb11474a619414E51Bd',
    [ChainId.BSC_MAINNET]: '0x5dF97c1666ac2268f4af5cA84b64eB28ae25bAD6'
  },
  tlm: {
    [ChainId.BSC_TESTNET]: '0x49F9776c03f2552644e9Ac7B5390C5155338FC02',
    [ChainId.BSC_MAINNET]: '0x2222227e22102fe3322098e4cbfe18cfebd57c95'
  },
  tlmMaster: {
    [ChainId.BSC_TESTNET]: '0x62F1008e4A24A70e0fcB5670550c66B917c420e4',
    [ChainId.BSC_MAINNET]: '0x4127f84f2B9F922259a10bfb8d32C56428A4E885'
  },
  tlmBakeBlp: {
    [ChainId.BSC_TESTNET]: '0xf03FDDf3E3BAf180B292552bEbD237b6a28c5375',
    [ChainId.BSC_MAINNET]: '0xe4a9b7dFd92E44CC914f8822819C3340FB5595D0'
  },
  hyFiBakeBaseIdo: {
    [ChainId.BSC_TESTNET]: '0x617F9A9728CEfDa49BC19053FDa2a44511cF2407',
    [ChainId.BSC_MAINNET]: '0x2595C56A28459D7BBe5d2e80564AADeF2e8E663a'
  },
  hyfiBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x26A2FcA546B02a12d0ba70e5D9fEAFE9149F1725',
    [ChainId.BSC_MAINNET]: '0x75E7E177Ae68BaD3ffB8519c2c389C1f8E017B5E'
  },
  hyfi: {
    [ChainId.BSC_TESTNET]: '0xd8A55C3DcCdC25b96F18178DDac53b057767b339',
    [ChainId.BSC_MAINNET]: '0x9a319b959e33369C5eaA494a770117eE3e585318'
  },
  hyfiMaster: {
    [ChainId.BSC_TESTNET]: '0xAf4e95C2eBfD5d6DB2cbe43336c10D427d1D3046',
    [ChainId.BSC_MAINNET]: '0x6bACD6598caAAe504e1bA24503c205cc42d5cF0f'
  },
  petBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x7499b895F98E4B6FEab59c51322527f9Dec80794',
    [ChainId.BSC_MAINNET]: '0x229E9F691ed34cf4cb706Fae7bF65AeB9020E329'
  },
  pet3Master: {
    [ChainId.BSC_TESTNET]: '0x27031d40B6DE00F9c8482Ba38B2F224C012D7A5E',
    [ChainId.BSC_MAINNET]: '0x7a7e491FD948B4c9d4C8A4c6D9A04Efb88dF2b93'
  },
  sact: {
    [ChainId.BSC_TESTNET]: '0xb3DB44A4C498bA6f239faFA2FcE8eAFFCa6EA70A',
    [ChainId.BSC_MAINNET]: '0x1bA8c21c623C843Cd4c60438d70E7Ad50f363fbb'
  },
  sactBakeBlp: {
    [ChainId.BSC_TESTNET]: '0x264dF58071af3DE9E55E7E21271764cFdcB0BB97',
    [ChainId.BSC_MAINNET]: '0x226975ad3F1B5ac252e63b551EB9E39E93317FAb'
  },
  sactMaster: {
    [ChainId.BSC_TESTNET]: '0xf6511a8B10b447655ac33c69348dD70D0fc1e5b3',
    [ChainId.BSC_MAINNET]: '0xb29484bc2Ded91CD17a16c40412D72B8c230d122'
  },
  xDitto: {
    [ChainId.BSC_TESTNET]: '0xbcE168b95F85B4EEF15f1de8B664b1F568098d29',
    [ChainId.BSC_MAINNET]: '0xB0a1DE764A033A76f28E821fBe402EDBFEe937dB'
  },
  xDittoBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x05435c0657f0193619921d66d562DCee027cb7eb',
    [ChainId.BSC_MAINNET]: '0x6f6fd56553F47e438BD47560f25B10834E6a39c9'
  },
  xDittoMaster: {
    [ChainId.BSC_TESTNET]: '0xb44A0Ecc6431054B2ed32ba7577939d6C3c0FA3D',
    [ChainId.BSC_MAINNET]: '0x3CAB992e0E5Bc3d19232bb4932593762DD34Df60'
  },
  gfx: {
    [ChainId.BSC_TESTNET]: '0x21EeD5382f47Fbe108c0b573Cd851e4E778f93b2',
    [ChainId.BSC_MAINNET]: '0xE4fA3C576c31696322e8d7165C5965d5a1F6A1A5'
  },
  gfxBnbBlp: {
    [ChainId.BSC_TESTNET]: '0xB60A52C12Ca256Fc03de948E7fF93ba1162B869A',
    [ChainId.BSC_MAINNET]: '0xFf2c85F199532bF30827416896d0809897208126'
  },
  gfxMaster: {
    [ChainId.BSC_TESTNET]: '0xBB2D44ca3ED34375aE05D44ED2942dda82322DF1',
    [ChainId.BSC_MAINNET]: '0xeF7EBbCf18c7B6861a02e17b2BBad9Bdb9923C77'
  },
  gamyfiBakeBaseIdo: {
    [ChainId.BSC_TESTNET]: '0x6a770601B5216B17D38bB0CFf01E0B0395201470',
    [ChainId.BSC_MAINNET]: '0x3Cd30012e6880c3C585770Cfa38FBD028555319B'
  },
  bakerySoccerStakingPowerToken: {
    [ChainId.BSC_TESTNET]: '0x01f474B0c5be88C9C3c27089dFdfB552804F4810',
    [ChainId.BSC_MAINNET]: '0x01f474B0c5be88C9C3c27089dFdfB552804F4810'
  },
  bakerySoccer: {
    [ChainId.BSC_TESTNET]: '0xD48e0b6052A04d89D9FD80dF4563BDf736078fE0',
    [ChainId.BSC_MAINNET]: '0xD48e0b6052A04d89D9FD80dF4563BDf736078fE0'
  },
  bakerySoccerMaster: {
    [ChainId.BSC_TESTNET]: '0x590536b46Cd6c879fB1b78FF57Ddf1336bE13827',
    [ChainId.BSC_MAINNET]: '0x590536b46Cd6c879fB1b78FF57Ddf1336bE13827'
  },
  exchangeBakerySoccer: {
    [ChainId.BSC_TESTNET]: '0xF064750006EBd0306E14E1CD5d709984Cc0a1840',
    [ChainId.BSC_MAINNET]: '0x7f67A8c7bC266B3ECC1D06b80925a40F71fA0E6C'
  },
  bidBakerySoccer: {
    [ChainId.BSC_TESTNET]: '0x4c6c49f0fb84074B58cB91193069c50a72EDdE85',
    [ChainId.BSC_MAINNET]: '0x4Ab5D6a60fAB7603a9Ea372F7721a2f6c931BA70'
  },
  dfy: {
    [ChainId.BSC_TESTNET]: '0x094DDc0759268Cb04eA3F1d44e0f8529C2d08105',
    [ChainId.BSC_MAINNET]: '0xD98560689C6e748DC37bc410B4d3096B1aA3D8C2'
  },
  dfyBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x85ff63A35F2EEf4aaC114685EEF7FF51826189e5',
    [ChainId.BSC_MAINNET]: '0xc55B33A76F401892840E8339d54018604B3203D8'
  },
  dfyBakeBlp: {
    [ChainId.BSC_TESTNET]: '0xbeAAC29A0CcC3C2aB66deF99baB334bdd0f13221',
    [ChainId.BSC_MAINNET]: '0x3c027bEa3e0f66C137AcBC8Be4b6C3E834579e9E'
  },
  dfyMaster: {
    [ChainId.BSC_TESTNET]: '0x63649C59BAfb49a6Aed195e8de8E064C91961ec3',
    [ChainId.BSC_MAINNET]: '0x987973c2A1A9F54F765258CB8b7F9e358796F393'
  },
  tct: {
    [ChainId.BSC_TESTNET]: '0xA79f71960fddE88704fd6A41fbeAd77Fdfb65910',
    [ChainId.BSC_MAINNET]: '0xCA0a9Df6a8cAD800046C1DDc5755810718b65C44'
  },
  tctBusdBlp: {
    [ChainId.BSC_TESTNET]: '0xc1B451Be06656c1bD9d5d6880a013dA196a5f38f',
    [ChainId.BSC_MAINNET]: '0x6c4109De1fE903216e304ba5fcFEB9f88de219Ba'
  },
  tctMaster: {
    [ChainId.BSC_TESTNET]: '0xE350108FA06c4725Bf78F2c8a58414f4676fdb4a',
    [ChainId.BSC_MAINNET]: '0xEae97a4b0b5B694390196334b31c92fEA8bbbD7C'
  },
  soccerBakeBaseIDO: {
    [ChainId.BSC_TESTNET]: '0x6594f9AA7A1FA9294c81bB9EB531492E5fC52Df6',
    [ChainId.BSC_MAINNET]: '0x41562EbFCB5655F2a534723E081CA0286C427feC'
  },
  soccer: {
    [ChainId.BSC_TESTNET]: '0x338d44d19c8d45ed9771b8D2B95D988F0e42187F',
    [ChainId.BSC_MAINNET]: '0x338d44d19c8d45ed9771b8D2B95D988F0e42187F'
  },
  soccerBakeBlp: {
    [ChainId.BSC_TESTNET]: '0xb487351823F3e8f88b10ADbF96d4a4E39Daf0da5',
    [ChainId.BSC_MAINNET]: '0xb487351823F3e8f88b10ADbF96d4a4E39Daf0da5'
  },
  soccerBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x7aded9622DED9E2CA77E2058Ba23d003A771BB8a',
    [ChainId.BSC_MAINNET]: '0x69b45802Bb25E2949b49b2A2946cFCA6648A36CC'
  },
  autoBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x95dDBe91724Eb58dc068979F35E2D3e4646D5aCF',
    [ChainId.BSC_MAINNET]: '0xDF388EF85179b239898DB0f6B9eA44f640042876'
  },
  aliceNft: {
    [ChainId.BSC_TESTNET]: '0x72ccF0bF7aD17130475Db3758430BF92af5AE68E',
    [ChainId.BSC_MAINNET]: '0x828E90cef49b3bAEa41590eBf7f274d49f845dbb'
  },
  aliceCommonNftMaster: {
    [ChainId.BSC_TESTNET]: '0x2683B7AE9a49E86Ee95D2632D010Dc2390De04B2',
    [ChainId.BSC_MAINNET]: '0xC38B3580941fFe79273760F8EeE74ceb8f64073A'
  },
  alice: {
    [ChainId.BSC_TESTNET]: '0x85aB05Eebc4Eb6d988e96938dcE3F9b0EaA18f89',
    [ChainId.BSC_MAINNET]: '0xAC51066d7bEC65Dc4589368da368b212745d63E8'
  },
  aliceMaster: {
    [ChainId.BSC_TESTNET]: '0x49C2205527011bF07B60B6dB7d4c79b013F1D00a',
    [ChainId.BSC_MAINNET]: '0xE4379Fc68a6e91Cb05F917B7De3F9E069C0e9161'
  },
  bakeAliceBlp: {
    [ChainId.BSC_TESTNET]: '0x2C896cDDEBcb31A4f8887558fc870f886ec35a49',
    [ChainId.BSC_MAINNET]: '0x0A84512f7cFcc69EAcE31B8A26cC96C2f3434b9E'
  },
  bakeBatBlp: {
    [ChainId.BSC_TESTNET]: '0xF1785c979E822134b6D5A9B23Bd75126388B23Df',
    [ChainId.BSC_MAINNET]: '0x675Ec26cF1c99A5cD227658f5d0e2fAcbbf3Dcf7'
  },
  oneInchBakeNFT: {
    [ChainId.BSC_TESTNET]: '0xb4484CACd4cdA038B7d7b261502E5cdFBab9eb5B',
    [ChainId.BSC_MAINNET]: '0x2B843942EdF0040012b12bE2b3C197Ef53cab7F9'
  },
  oneInchBakeCommonNftMaster: {
    [ChainId.BSC_TESTNET]: '0xe55E1f4c636DA855d0808983BAb2877300580416',
    [ChainId.BSC_MAINNET]: '0xF65144C7D4eA2F04d079EcbE1a7F52000c1c4f20'
  },
  oneInch: {
    [ChainId.BSC_TESTNET]: '0x13373DF023f90D0baE4cF7BcBFF798F87FA45A44',
    [ChainId.BSC_MAINNET]: '0x111111111117dc0aa78b770fa6a738034120c302'
  },
  exchangeOneInchBakeNFT: {
    [ChainId.BSC_TESTNET]: '0x1753091b502B797B8b545aE890AD2936A7588696',
    [ChainId.BSC_MAINNET]: '0x961985030bC6cB35a8bf2bfeFf32FF0512f4D3b0'
  },
  bidOneInchBakeNFT: {
    [ChainId.BSC_TESTNET]: '0xEF8806D4Ff16Cc555E2C693a1795CdC0d00B7727',
    [ChainId.BSC_MAINNET]: '0xea8683ed461ED504F08078903C2C89ee5F40A8A7'
  },
  busd: {
    [ChainId.BSC_TESTNET]: '0xed24fc36d5ee211ea25a80239fb8c4cfd80f12ee',
    [ChainId.BSC_MAINNET]: '0xe9e7cea3dedca5984780bafc599bd69add087d56'
  },
  busdUsdcBlp: {
    [ChainId.BSC_TESTNET]: '0xA29122631a683EeFe5696F678e9DDbFA5415a537',
    [ChainId.BSC_MAINNET]: '0x56CDE265aaD310e623C8f8994a5143582659aBfC'
  },
  mx: {
    [ChainId.BSC_TESTNET]: '0x54991a494a05C2435E73C34782b8cCF954c77099',
    [ChainId.BSC_MAINNET]: '0x9F882567A62a5560d147d64871776EeA72Df41D3'
  },
  bakeMxBlp: {
    [ChainId.BSC_TESTNET]: '0x22ca1a9ac0c9393b86f4097b7bd9d003cb12acf2',
    [ChainId.BSC_MAINNET]: '0x0af49D51E2136af95646527263bACbA004eb4884'
  },
  mxMaster: {
    [ChainId.BSC_TESTNET]: '0x7469A0B95FF8649bCcfa9d10F8D7e01DbEF9791f',
    [ChainId.BSC_MAINNET]: '0xBF94CC0BbE177C6E0d2d581cA20dcF7CBd50B8f4'
  },
  diesel: {
    [ChainId.BSC_TESTNET]: '0x398F3AC457a965493C7D9E35158Ab716A40Edd76',
    [ChainId.BSC_MAINNET]: '0xe1eA2E1907d93F154234CE3b5A7418faf175fE11'
  },
  dieselMaster: {
    [ChainId.BSC_TESTNET]: '0x5f44f198115E0e856440473620c44E5Ceb267306',
    [ChainId.BSC_MAINNET]: '0xA3138cF6AA7ac5F6D27adFf863D92d5717a47402'
  },
  bnbDieselBlp: {
    [ChainId.BSC_TESTNET]: '0xc09D61E531Acbc58c66F22Cf8265bD5061A0cEd8',
    [ChainId.BSC_MAINNET]: '0x2077bB2BAbf6e78dE2825143a1C03AbFe974DbeA'
  },
  voteForNFT: {
    [ChainId.BSC_TESTNET]: '0x87CAdb6185EcFb54E6bd46541581D727d497E0F5',
    [ChainId.BSC_MAINNET]: '0xdCb42F9b544312aBdC9c6145a9F0Af590e4b535E'
  },
  tko: {
    [ChainId.BSC_TESTNET]: '0x07D31D1CE720c3730c09Bc01637742944Fd910C0',
    [ChainId.BSC_MAINNET]: '0x9f589e3eabe42ebC94A44727b3f3531C0c877809'
  },
  tkoBusdBlp: {
    [ChainId.BSC_TESTNET]: '0x64CED8A7B6076c4B6E2c5Ab2c7C69BF16e6bE421',
    [ChainId.BSC_MAINNET]: '0xA564288e789c297A74ec9BBB1e5f0619C96Ca746'
  },
  tkoBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x65E991405Bc6C3c2c392F9a73e86eb5afEA1681F',
    [ChainId.BSC_MAINNET]: '0x1d810281F70247Ba13eA34872251030B0e1C8265'
  },
  tkoMaster2: {
    [ChainId.BSC_TESTNET]: '0xa4825FAFaFDE051ECD9dc39943276289513383E5',
    [ChainId.BSC_MAINNET]: '0xD4F889108a4753E5fD7b64707c3703b54Ff8D23e'
  },
  tkoBakeBlp: {
    [ChainId.BSC_TESTNET]: '0xF72345324eE783d986F73e01fCd7824BDC655cA7',
    [ChainId.BSC_MAINNET]: '0x9c34e4145A5E9beD87f45353aB17Cd2B179b7262'
  },
  tkoMaster: {
    [ChainId.BSC_TESTNET]: '0xeB067693F44c14c379457DBDC81Efbc06c1C1858',
    [ChainId.BSC_MAINNET]: '0x95e8026364A29cdA88049b23c65AC411ceA4715A'
  },
  tkoCommonStakeERC721EarnERC20: {
    [ChainId.BSC_TESTNET]: '0x846aA62DbF49C74604e07fc1772f4545F1e4Cd57',
    [ChainId.BSC_MAINNET]: '0x174fB5f3C31b865043F9Eb5d6EdcAe2856710304'
  },
  tokocryptoNft: {
    [ChainId.BSC_TESTNET]: '0x3A1c331Bb2cBA92F3F623068947bAbAE3ed99A36',
    [ChainId.BSC_MAINNET]: '0x3A1c331Bb2cBA92F3F623068947bAbAE3ed99A36'
  },
  tokocryptoCommonNftMaster: {
    [ChainId.BSC_TESTNET]: '0x9E5aB10f4d9Fac4fA8B4306C7d115fBcaC3869da',
    [ChainId.BSC_MAINNET]: '0x5466Bbb3c6280943C8A9b0c39e3ad7D31b2bB78D'
  },
  exchangeTokocryptoNFT: {
    [ChainId.BSC_TESTNET]: '0xA2734393C1b8880aEF94026699F4eCcCc8dC89AC',
    [ChainId.BSC_MAINNET]: '0xcfb27c7F778780178e95feA84c45e5D79F0a0a4E'
  },
  bidTokocryptoNFT: {
    [ChainId.BSC_TESTNET]: '0xCA8e8E83856758b01488d904e5aBE85d21d743EF',
    [ChainId.BSC_MAINNET]: '0xE4D3299B1a3C268814C57394c2a729FecA3b2B00'
  },
  war: {
    [ChainId.BSC_TESTNET]: '0x9f0D3d71a1C58a1025701929Be99D23B3eA7e607',
    [ChainId.BSC_MAINNET]: '0x42dbD44a8883D4363B395F77547812DC7dB806d5'
  },
  bakeWarBlp: {
    [ChainId.BSC_TESTNET]: '0x2759a262108Ca345e1F40F13774040ec8Be9Eeb6',
    [ChainId.BSC_MAINNET]: '0x8B4Fa3e7F29924b6A60C4abaC0db9dEA0DF594ba'
  },
  warMaster: {
    [ChainId.BSC_TESTNET]: '0x7bf4bed035a54589082b73a5d6e41413da981f09',
    [ChainId.BSC_MAINNET]: '0x52c26308fe70fd188c7efaad11663e5b3ead42c9'
  },
  busdWarBlp: {
    [ChainId.BSC_TESTNET]: '0xf08957d003208a23508fe9054fafd7217c789825',
    [ChainId.BSC_MAINNET]: '0x083593735495EE0EB7D8716470D7683c1b852ca5'
  },
  warMaster2: {
    [ChainId.BSC_TESTNET]: '0x35750aFd872FB6fFCD5c7DCe8904f8edD9a129Ce',
    [ChainId.BSC_MAINNET]: '0x77Bfd5d645010F5d798a3a481E122eC8F291eDCE'
  },
  seascapeNFT: {
    [ChainId.BSC_TESTNET]: '0x66638f4970c2ae63773946906922c07a583b6069',
    [ChainId.BSC_MAINNET]: '0xc54b96b04AA8828b63Cf250408E1084E9F6Ac6c8'
  },
  seascapeCommonNftMaster: {
    [ChainId.BSC_TESTNET]: '0xd7292499CC94016c4265Af49034e58018399151E',
    [ChainId.BSC_MAINNET]: '0xA491395865cA3Ef828E4a879D3d2de7C7eC94689'
  },
  pCWSBakeBlp: {
    [ChainId.BSC_TESTNET]: '0x8c72CbDaCb26f15e1a73D78dE1265C963ACed502',
    [ChainId.BSC_MAINNET]: '0x14BC29C27899E33fdD7169407216C86Fa947c537'
  },
  exchangeSeascapeNFT: {
    [ChainId.BSC_TESTNET]: '0x196a6D38b0048aC41c3819476177fCC22d3ec081',
    [ChainId.BSC_MAINNET]: '0x773028cD87f93dfA67E2F5FeC01DB4EA82Cc4b07'
  },
  bidSeascapeNFT: {
    [ChainId.BSC_TESTNET]: '0xb8737421ab10EeDB01F1d7c30c5ad5F0ebB6Afb5',
    [ChainId.BSC_MAINNET]: '0x498a5E8A34A85845DeD8869d5638B2E2ff91D979'
  },
  pCWSBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x4353A4E7eC5836Fc798308555e153765fA7Ee1B5',
    [ChainId.BSC_MAINNET]: '0xe67B96a9456E6e623463d022Fbb949a3fdD9Ed4C'
  },
  pCWS: {
    [ChainId.BSC_TESTNET]: '0xE17626fC6C189640057Aa4b7fFb272CB7E3A4ea7',
    [ChainId.BSC_MAINNET]: '0xbcf39F0EDDa668C58371E519AF37CA705f2bFcbd'
  },
  pCWSMaster: {
    [ChainId.BSC_TESTNET]: '0xdC2df521fBe550446F0C0e8d98f2C01eb781b0cd',
    [ChainId.BSC_MAINNET]: '0x540360fF1B002aFEd972cFFcB05B6ff478Ca05C2'
  },
  BANANA: {
    [ChainId.BSC_TESTNET]: '0x3D66334d92A00e5Ca199682C67d166Ffee1DB928',
    [ChainId.BSC_MAINNET]: '0x603c7f932ED1fc6575303D8Fb018fDCBb0f39a95'
  },
  bakeBananaBlp: {
    [ChainId.BSC_TESTNET]: '0xA0acf95c4A3a89A6e0b219eb895DF065c48983B5',
    [ChainId.BSC_MAINNET]: '0x61890bd5AF37A44f15a697f9db9BfcCeAbF4e322'
  },
  BANANAMaster: {
    [ChainId.BSC_TESTNET]: '0x5b588A2061441832fF654b513Dd3a3fDc5dbB685',
    [ChainId.BSC_MAINNET]: '0x35dafafE18B65cEBA36350DCf4EeB618Ad2B8387'
  },
  crudeoilBakeBaseIDO: {
    [ChainId.BSC_TESTNET]: '0x3deB2265C986d34532C699abb911AD0c3e837E49',
    [ChainId.BSC_MAINNET]: '0xD2dbbE23baa58e3D56eBd388CfF6791B560F2347'
  },
  spartanBakeBaseIDO: {
    [ChainId.BSC_TESTNET]: '0x09C9177EAe955ccFC9dED783C5886086D30621c0',
    [ChainId.BSC_MAINNET]: '0x67F633FfBB430551893EB2B8e63D211c2B386CC9'
  },
  bidBakeryArtwork3NFT: {
    [ChainId.BSC_TESTNET]: '0x0CE4128c061708718c1a519c11d31d80F297cf9b',
    [ChainId.BSC_MAINNET]: '0xe98631Ce5ccf1e9eF1638a76C78702a384A79E29'
  },
  bakeryArtwork3NFT: {
    [ChainId.BSC_TESTNET]: '0x241DDDC8fa9628923761D94779778288E69C9209',
    [ChainId.BSC_MAINNET]: '0x84d7FE5D949eA5fec5D84617bAdD7590275bFa72'
  },
  exchangeBakeryArtwork3NFT: {
    [ChainId.BSC_TESTNET]: '0x73BD5E9FD21b53BDb455689feA4b03cba0Ffa2E6',
    [ChainId.BSC_MAINNET]: '0x8fb398BE7ACb7110436749A394e3D672b8Ddb2ff'
  },
  DEFI100: {
    [ChainId.BSC_TESTNET]: '0x34EE4d1dDD4DE53958BfC562EB7D9b7B4c8fedAb',
    [ChainId.BSC_MAINNET]: '0x9d8AAC497A4b8fe697dd63101d793F0C6A6EEbB6'
  },
  DEFI100Master: {
    [ChainId.BSC_TESTNET]: '0xA71024785a10786D45ab3F82062ef704aD763355',
    [ChainId.BSC_MAINNET]: '0xf5Df2D28309095c5212F395A4B571cAcE5C2058C'
  },
  DEFI100OldMaster: {
    [ChainId.BSC_TESTNET]: '0xA71024785a10786D45ab3F82062ef704aD763355',
    [ChainId.BSC_MAINNET]: '0x4302b66b1b923171FBF44AeA0ee5a21e687409eC'
  },
  DEFI100BakeBLP: {
    [ChainId.BSC_TESTNET]: '0x05864D0bda90113Bb300355c6726a96d8f97Be0a',
    [ChainId.BSC_MAINNET]: '0x237E5251371A9Ce542829a8888B9C3BF05F68522'
  },
  DEFI100BnbBLP: {
    [ChainId.BSC_TESTNET]: '0x9872624A2b6B7c6444AAa1681146A700d4Fc00a7',
    [ChainId.BSC_MAINNET]: '0x6ba40C79C2Da5d6faF29B1eDac8C15e1fb8f7aB1'
  },
  aeth: {
    [ChainId.BSC_TESTNET]: '0xe82ec65D01E3866c906B608234dd6873C7bbCf73',
    [ChainId.BSC_MAINNET]: '0x973616ff3b9d8F88411C5b4E6F928EE541e4d01f'
  },
  ankr: {
    [ChainId.BSC_TESTNET]: '0x0C3393DB8B57aF9AE636E502C728E5b3c24c1Ab8',
    [ChainId.BSC_MAINNET]: '0xf307910A4c7bbc79691fD374889b36d8531B08e3'
  },
  onx: {
    [ChainId.BSC_TESTNET]: '0xcD73CcDE7d66768d0f64528762CdebE72d198f36',
    [ChainId.BSC_MAINNET]: '0x50dfd52c9f6961Bf94D1d5489AE4B3e37D2F1fe7'
  },
  aethMaster: {
    [ChainId.BSC_TESTNET]: '0x15559497E14E2BB948dE402Fd75627fab3CE88e0',
    [ChainId.BSC_MAINNET]: '0xed8732d98ADb5591e9FC9a15BbA7a345B78B3e0E'
  },
  BRYBakeBLP: {
    [ChainId.BSC_TESTNET]: '0x7508a0Cb9F432B2Fd4ffCD5a2632144A990935b2',
    [ChainId.BSC_MAINNET]: '0x79249E6b65030902671c5Fa85d79E3ec28e4b1b9'
  },
  BRY: {
    [ChainId.BSC_TESTNET]: '0x205E58A7b8B2D37e153b5217feB754967586E91e',
    [ChainId.BSC_MAINNET]: '0xf859Bf77cBe8699013d6Dbc7C2b926Aaf307F830'
  },
  BRYMaster: {
    [ChainId.BSC_TESTNET]: '0xe29B3775425F8EC90db14dA9c53a08BC0235ce7A',
    [ChainId.BSC_MAINNET]: '0xA9E34CB291B64d3ad56B365ADDE369f3Ec04F7a8'
  },
  SHIELD: {
    [ChainId.BSC_TESTNET]: '0x5Bae754F693af19aCfAcf6cb2F4b8F592b68f8AA',
    [ChainId.BSC_MAINNET]: '0x60b3BC37593853c04410c4F07fE4D6748245BF77'
  },
  SHIELDMaster: {
    [ChainId.BSC_TESTNET]: '0xc86c91C0120cd1cFDb4513A9b49F34F0dD4d4A2e',
    [ChainId.BSC_MAINNET]: '0x9C94E850DB4371B38c00F60F9cE111694b212C30'
  },
  wSOTE: {
    [ChainId.BSC_TESTNET]: '0xB939376da0b3C7f47f320580CbB6B2608DB20F58',
    [ChainId.BSC_MAINNET]: '0x541e619858737031a1244a5d0cd47e5ef480342c'
  },
  wSOTEMaster: {
    [ChainId.BSC_TESTNET]: '0x63A535209D8A6c01D5e382f982aFa062a45b233d',
    [ChainId.BSC_MAINNET]: '0x99638fD577C22fc752B3734103933CF9835C5e02'
  },
  wSoteBakeBLP: {
    [ChainId.BSC_TESTNET]: '0x511b69183ee7e983afdc0a48e33310008ee88d20',
    [ChainId.BSC_MAINNET]: '0x7dbc5d1f167b476e7c8866d6e8221d210547ab88'
  },
  ten: {
    [ChainId.BSC_TESTNET]: '0x81fe632De52041d1c7E6C23a42B215a601a7D716',
    [ChainId.BSC_MAINNET]: '0xdFF8cb622790b7F92686c722b02CaB55592f152C'
  },
  tenMaster: {
    [ChainId.BSC_TESTNET]: '0xCB3491E145f78C1d8350B50AA4298a16e310D90A',
    [ChainId.BSC_MAINNET]: '0x4D6D2e3B419D324b77dDCAf3Ff17A66C7D16e9f5'
  },
  tenPetNftMaster: {
    [ChainId.BSC_TESTNET]: '0x99fe3638286499cf0e35Cea3abd83b7677cE2c55',
    [ChainId.BSC_MAINNET]: '0x7c9378d17534a476d8741f26a46cbae1a0788bd5'
  },
  tenBakeBLP: {
    [ChainId.BSC_TESTNET]: '0x6276658502bB1660BCd815B7e1004C041547963D',
    [ChainId.BSC_MAINNET]: '0x101E83700c5dE0Bc4F5a65471A26DA6B141EA478'
  },
  beth: {
    [ChainId.BSC_TESTNET]: '0x747c58A36Fe414032072d671ccdf38720aDDb1a9',
    [ChainId.BSC_MAINNET]: '0x250632378E573c6Be1AC2f97Fcdf00515d0Aa91B'
  },
  bethBakeBLP: {
    [ChainId.BSC_TESTNET]: '0xfef3ec19d4b48c9d75684c2ca7527b9ddbae53fe',
    [ChainId.BSC_MAINNET]: '0x53920d115CeC3E94dFeae52CA515093e84858109'
  },
  eth2Master: {
    [ChainId.BSC_TESTNET]: '0x377C901Dc5f752C110dB33A526cAA327454F5Cf0',
    [ChainId.BSC_MAINNET]: '0xe627f00D5a5bfcE0640E771Af573C41e9a278A20'
  },
  helmetNftCommonMaster: {
    [ChainId.BSC_TESTNET]: '0x1B16aF670b0017ffD5E026008078599c322c50CF',
    [ChainId.BSC_MAINNET]: '0x163454D6313DC09eD376da6760cBEeA1efE2acF5'
  },
  helmetNft: {
    [ChainId.BSC_TESTNET]: '0xd97B0aDaFf4C8bd19a2587ce07f8416ad0860C90',
    [ChainId.BSC_MAINNET]: '0x2f0f57BADc77701E9e6384b9335cB9AA4900b08A'
  },
  petNFTCommonMaster: {
    [ChainId.BSC_TESTNET]: '0x68cA8D5Bf0aDA9f7dA0530bdbdcC324e37622d75',
    [ChainId.BSC_MAINNET]: '0x68cA8D5Bf0aDA9f7dA0530bdbdcC324e37622d75' // TODO
  },
  weaponNFTCommonMaster: {
    [ChainId.BSC_TESTNET]: '0x7fF8C60852834937BAb6ec3adb4403fE669628Cc',
    [ChainId.BSC_MAINNET]: '0x7fF8C60852834937BAb6ec3adb4403fE669628Cc' // TODO
  },
  petNft: {
    [ChainId.BSC_TESTNET]: '0xAa4cDa1838Ab17F6554EB2F1b3a65214083dF3f7',
    [ChainId.BSC_MAINNET]: '0x90E88d4c8E8f19af15DfEabD516d80666F06A2F5'
  },
  exchangePetNft: {
    [ChainId.BSC_TESTNET]: '0xc51Eadfb14e13b0071464a504167bc6868Fe6eEa',
    [ChainId.BSC_MAINNET]: '0xa3514F8ee39Ba80cD36B4aecfa2Fe2eb5fD6b326'
  },
  // bid pet nft
  bidPetNFT: {
    [ChainId.BSC_TESTNET]: '0xf6D05A90337596F3273a8A1914A1b4E94303767f',
    [ChainId.BSC_MAINNET]: '0x3bD857648Da97f3c395546E4F7F9fAD3aF29da33'
  },
  bestToken: {
    [ChainId.BSC_TESTNET]: '0xAE8044eF4264E672e142cA4d9fcD92135e8d2592',
    [ChainId.BSC_MAINNET]: '0x10747e2045a0ef884a0586AC81558F43285ea3c7'
  },
  bestMaster: {
    [ChainId.BSC_TESTNET]: '0x31f9B1f691884a8A744DCf29714d6B37bfB5E909',
    [ChainId.BSC_MAINNET]: '0x62Da74a42de360f1B5882d63e1E480fb80F0956f'
  },
  busdToken: {
    [ChainId.BSC_TESTNET]: '0xed24fc36d5ee211ea25a80239fb8c4cfd80f12ee',
    [ChainId.BSC_MAINNET]: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56'
  },
  usdtToken: {
    [ChainId.BSC_TESTNET]: '0x337610d27c682E347C9cD60BD4b3b107C9d34dDd',
    [ChainId.BSC_MAINNET]: '0x55d398326f99059ff775485246999027b3197955'
  },
  transfer: {
    [ChainId.BSC_TESTNET]: '0x626d260DaAf60D0c1C52E9eB8F166055d3Ee59CC',
    [ChainId.BSC_MAINNET]: '0xf8177Cda1b5B5B022F7a87546Dcb646C5562E952'
  },
  weapon: {
    [ChainId.BSC_TESTNET]: '0x84525cE72f4f10C1Daa471C17f0DE14F96cd3132',
    [ChainId.BSC_MAINNET]: '0x3664d30A612824617e3Cf6935d6c762c8B476eDA'
  },
  weaponBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x88DCB0614138e4a7e0f24c9DF383309cD9D7dd16',
    [ChainId.BSC_MAINNET]: '0x9b947628799b133df97315A8172627c9e46aBB1b'
  },
  weaponMaster: {
    [ChainId.BSC_TESTNET]: '0x5D036Eae933Bb2c7a00b97387D95eB74E6A8b24a',
    [ChainId.BSC_MAINNET]: '0x0c2fC172c822B923f92A17aD9EA5c15aD7332624'
  },
  weaponNFT: {
    [ChainId.BSC_TESTNET]: '0x2F2d38bC4C9d7b2A57432d8a7AB2093a432885Ca',
    [ChainId.BSC_MAINNET]: '0xBe7095dBBe04E8374ea5F9f5B3f30A48D57cb004'
  },
  exchangeWeaponNFT: {
    [ChainId.BSC_TESTNET]: '0xf9128Cd6D8B63106Da4058491A495b3Eb96afC5C',
    [ChainId.BSC_MAINNET]: '0xA4C3a8F8465FdDdE98A440f8cF5E180e6e33f644'
  },
  // bid weapon nft
  bidWeaponNFT: {
    [ChainId.BSC_TESTNET]: '0xE8931c2a02c75e547FA3b9aE8D2324c544bEF2C6',
    [ChainId.BSC_MAINNET]: '0x61E9181E7Fece6e2a79e1abfF71ACB99bd98E3E3'
  },
  binanceNft: {
    [ChainId.BSC_TESTNET]: '0x9D540ff9Af51178cB285Dc19629f9a7b2F9408Be',
    [ChainId.BSC_MAINNET]: '0xc014B45D680B5a4bf51cCdA778A68d5251C14b5E'
  },
  exchangeBinanceNft: {
    [ChainId.BSC_TESTNET]: '0xb40d08e866693E4A4AC6556A533D996DED5e7458',
    [ChainId.BSC_MAINNET]: '0x58e6E6e16A8fd619b6DE1dA4F614dfB31dcC07b2'
  },
  // bid binance nft
  bidBinanceNFT: {
    [ChainId.BSC_TESTNET]: '0x8A9b166E8cc39815B7D0D96F1D9f88EeFC774012',
    [ChainId.BSC_MAINNET]: '0xEF44A8D2830DFaC64A7493Ae60850cfb950567e1'
  },
  bakeryArtwork2NFT: {
    [ChainId.BSC_TESTNET]: '0xFfe09E64396d1b717DeF289A3aCB9F55d0A523A0',
    [ChainId.BSC_MAINNET]: '0x1233B9f706cB9028a03B61AF125cf1Fe840CDBD3'
  },
  exchangeBakeryArtwork2NFT: {
    [ChainId.BSC_TESTNET]: '0xC9DaA8877e21eF6Df3B9F25C4FE8F65B790E3329',
    [ChainId.BSC_MAINNET]: '0xC921239C1b5deaD79C889af1D9E006ef560FfFeA'
  },
  bidBakeryArtwork2NFT: {
    [ChainId.BSC_TESTNET]: '0x864BdcAd8dd09394711c28256a136D2a248fc8A5',
    [ChainId.BSC_MAINNET]: '0x616Ea437dFBf929ef49116614F6B2b610F48b0ae'
  },
  dogeMemeNFT: {
    [ChainId.BSC_TESTNET]: '0x241DDDC8fa9628923761D94779778288E69C9209',
    [ChainId.BSC_MAINNET]: '0x84d7FE5D949eA5fec5D84617bAdD7590275bFa72'
  },
  exchangeDogeMemeNFT: {
    [ChainId.BSC_TESTNET]: '0x73BD5E9FD21b53BDb455689feA4b03cba0Ffa2E6',
    [ChainId.BSC_MAINNET]: '0x8fb398BE7ACb7110436749A394e3D672b8Ddb2ff'
  },
  bidDogeMemeNFT: {
    [ChainId.BSC_TESTNET]: '0x0CE4128c061708718c1a519c11d31d80F297cf9b',
    [ChainId.BSC_MAINNET]: '0xe98631Ce5ccf1e9eF1638a76C78702a384A79E29'
  },
  reviewAddress: {
    [ChainId.BSC_TESTNET]: [
      '0xf04b7030Fd3787bE7ad8f1Cb13979690a831E9bC',
      '0x6fa3364792C9474b3B74A7d9A41D37be30c84D6B',
      '0x5425Ec0cBA7767C11cb5835aFaEE8DeB7C99f1BE',
      '0x4627a245f31A325F986FbB0528B04bF56977fD8A',
      '0x83B69ab825d3dd803ECc868198A08A8170eF97D4',
      '0x626d260DaAf60D0c1C52E9eB8F166055d3Ee59CC',
      '0x5e03bE5F99D3fE5b771711ac874344b41f4f1eD4',
      '0x8935dF9aa4856205526955159ffCa12DfB4EBb7f',
      '0x8fD1d21DF0E2b621c2E67c5043DDcFBd4B8E8ac5'
    ],
    [ChainId.BSC_MAINNET]: [
      '0xf04b7030Fd3787bE7ad8f1Cb13979690a831E9bC',
      '0x6fa3364792C9474b3B74A7d9A41D37be30c84D6B',
      '0x5425Ec0cBA7767C11cb5835aFaEE8DeB7C99f1BE',
      '0x4627a245f31A325F986FbB0528B04bF56977fD8A',
      '0x83B69ab825d3dd803ECc868198A08A8170eF97D4',
      '0x626d260DaAf60D0c1C52E9eB8F166055d3Ee59CC',
      '0x5e03bE5F99D3fE5b771711ac874344b41f4f1eD4',
      '0x8935dF9aa4856205526955159ffCa12DfB4EBb7f',
      '0x8fD1d21DF0E2b621c2E67c5043DDcFBd4B8E8ac5'
    ] // TODO
  },
  bakeryArtworkNFT: {
    [ChainId.BSC_TESTNET]: '0xC6911A6E1824b626dB9562df9A4634aE7BeE3621',
    [ChainId.BSC_MAINNET]: '0x5Bc94e9347F3b9Be8415bDfd24af16666704E44f'
  },
  exchangeBakeryArtworkNFT: {
    [ChainId.BSC_TESTNET]: '0x44Eb2059D03a189776f4A9F9f36dddB51FC6d582',
    [ChainId.BSC_MAINNET]: '0x26b82AB8269B2aD48FBDbbC9a08c78df7D68E814'
  },
  // bid bakery artwork nft
  bidBakeryArtworkNFT: {
    [ChainId.BSC_TESTNET]: '0x865D9379d9b2D20ECe1Bf0aEA1D933D75A81C7CD',
    [ChainId.BSC_MAINNET]: '0xE84E73889CDF43dbB57fFee42DC0615eb244891E'
  },
  bakeryArtworkRouter: {
    [ChainId.BSC_TESTNET]: '0x4090B62C9098731C4d9C03A0d9a0A99F0D3Ed30E',
    [ChainId.BSC_MAINNET]: '0x4A2a35D0D259ecd344FaB05adEb9c72389ADF2D8' // **没有发主网，主网没用这个合约
  },
  digitalArtworkNft: {
    [ChainId.BSC_TESTNET]: '0xe5f1ac1971f28cf8cbea5fee6fe61b1dd8908141',
    [ChainId.BSC_MAINNET]: '0xbc9535ceb418a27027f5cc560440f4a8823cb8bf'
  },
  exchangeArtworkNFT: {
    [ChainId.BSC_TESTNET]: '0x1BcD5753f219B776c668f3942a1b5436103482f6',
    [ChainId.BSC_MAINNET]: '0x59dC5A288dA642beAcA7bD0016065609fC06DF61'
  },
  // bid digital artwork nft
  bidDigitalArtworkNFT: {
    [ChainId.BSC_TESTNET]: '0x6A5aEDF1e54B9Ac41F6fEe5D3363d3970773f511',
    [ChainId.BSC_MAINNET]: '0x0c7Ab53232DA9a525ee93d20FD0BE256F512Cf8e'
  },
  petMaster2: {
    [ChainId.BSC_TESTNET]: '0xdB4d137261bA793d67d2A375d4aaA55F2eE1E396',
    [ChainId.BSC_MAINNET]: '0x5d2FE774032596D2C69Dc441fD137A1F43725E08'
  },
  exchangeEggNFT: {
    [ChainId.BSC_TESTNET]: '0x09B3B152E20ABACd0C67C8784bA8A25063D985CB',
    [ChainId.BSC_MAINNET]: '0x8443BE845c3D03Ac723411861025d0e8F453950f'
  },
  // bid pet egg nft
  bidPetEggNFT: {
    [ChainId.BSC_TESTNET]: '0x1a70E2a27E18adAdeD9015Bec58605A583Ef105b',
    [ChainId.BSC_MAINNET]: '0x437bf818Ae0b62C0E1Ad823877e2e5C25d07682B'
  },
  petEggNft: {
    [ChainId.BSC_TESTNET]: '0x0B619B394cA844576E571E43b6A120882Eb8C59a',
    [ChainId.BSC_MAINNET]: '0x8A3ACae3CD954fEdE1B46a6cc79f9189a6C79c56'
  },
  pet: {
    [ChainId.BSC_TESTNET]: '0xe59af933b309aFF12f323111B2B1648fF45D5dc0',
    [ChainId.BSC_MAINNET]: '0x4d4e595d643dc61EA7FCbF12e4b1AAA39f9975B8'
  },
  petMaster: {
    [ChainId.BSC_TESTNET]: '0xfe292e44fE33579b3690dE57302263B3d6B59739',
    [ChainId.BSC_MAINNET]: '0x4A2a35D0D259ecd344FaB05adEb9c72389ADF2D8'
  },
  dishStakingPowerToken: {
    [ChainId.BSC_TESTNET]: '0x32768bAc0CF6Ca49d894E5635fB9F80B7F3B726b',
    [ChainId.BSC_MAINNET]: '0x54F135A5fB523E467bcD6aA934939E1F25382275'
  },
  dish: {
    [ChainId.BSC_TESTNET]: '0xC3a7736b284cE163c45D92b75da4d4A34847be63',
    [ChainId.BSC_MAINNET]: '0xa7463C3163962b12AEB623147c2043Bb54834962',
    42: '0x43a7903E3a839a67192151eE300e11198985E54b',
    1: '0x6b3595068778dd592e39a122f4f5a5cf09c90fe2'
  },
  dishMaster: {
    [ChainId.BSC_TESTNET]: '0x22CbdB1Da36B35725d1D75A7784271EE3f869b30',
    [ChainId.BSC_MAINNET]: '0x7145319189629AFcF31754D8AC459265FCa4cF91',
    42: '0x43a7903E3a839a67192151eE300e11198985E54b',
    1: '0x6b3595068778dd592e39a122f4f5a5cf09c90fe2'
  },
  exchangeNFT: {
    [ChainId.BSC_TESTNET]: '0x6ebF7b9F11a81101d4a929e19FCefba72e8AE5cc',
    [ChainId.BSC_MAINNET]: '0x05D189D22D9916837A82438D74F3837Ac70b2831'
  },
  // bid dish nft
  bidDishNFT: {
    [ChainId.BSC_TESTNET]: '0x7D055aB74Cf65fb1a3C62A3F7c74172F19a39086',
    [ChainId.BSC_MAINNET]: '0x2D01300340bF6bFad0D7f830102188D6291dDc15'
  },
  nftHelper: {
    [ChainId.BSC_TESTNET]: '0x67C148d11554352E04098826D8aAE74294AC057d',
    [ChainId.BSC_MAINNET]: '0x0b6fB6D8e05B59bb24bf2a184a8f73Bb390FBE50'
  },
  bakeBnbBlp: {
    [ChainId.BSC_TESTNET]: '0x47d34Fd4f095767E718F110AfEf030bb18E8C48F',
    [ChainId.BSC_MAINNET]: '0xc2Eed0F5a0dc28cfa895084bC0a9B8B8279aE492'
  },
  sushi: {
    [ChainId.BSC_TESTNET]: '0xe02df9e3e622debdd69fb838bb799e3f168902c5',
    [ChainId.BSC_MAINNET]: '0xe02df9e3e622debdd69fb838bb799e3f168902c5',
    // [ChainId.BSC_MAINNET]: '0x918DE02364E0b63CE83e3741d254D19D8FE8f914', // 主网预生产合约
    42: '0x43a7903E3a839a67192151eE300e11198985E54b',
    1: '0x6b3595068778dd592e39a122f4f5a5cf09c90fe2'
  },
  masterChef: {
    [ChainId.BSC_TESTNET]: '0x20eC291bB8459b6145317E7126532CE7EcE5056f',
    [ChainId.BSC_MAINNET]: '0x20eC291bB8459b6145317E7126532CE7EcE5056f',
    // [ChainId.BSC_MAINNET]: '0xBd9695B0F5fBC902cb55e2F2F5d2cf0A7002c834', // 主网预生产合约
    1: '0xc2edad668740f1aa35e4d8f227fb8e17dca888cd'
  },
  weth: {
    [ChainId.BSC_TESTNET]: '0x094616f0bdfb0b526bd735bf66eca0ad254ca81f', // WBNB
    [ChainId.BSC_MAINNET]: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    1: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'
  },
  bakeDestroyed: {
    [ChainId.BSC_TESTNET]: '0x3aDa268097c7d9973A2D4cCD1ca939c386AbCFb7',
    [ChainId.BSC_MAINNET]: '0x732B6620D3469204BCC6F44c0b40cD8C4bAfC747' // 主网生产
    // [ChainId.BSC_MAINNET]: '0x8d01c3d91A22ca77A4B33e5e82b9e1eE48e78542' // 主网预生产合约
  },
  bakeDestroyedManager: {
    [ChainId.BSC_TESTNET]: '0x337E3Cee9c3e892F84c76B0Ec2C06fd4Ab06A734',
    [ChainId.BSC_MAINNET]: '0x2dab7D9A2A8c5a4e085377043619D2e7f2914700' // 主网生产
    // [ChainId.BSC_MAINNET]: '0x03FFFEF727C4e85468130aA0513e0428c6CFeFB1' // 主网预生产合约
  }
}

// mint bake pools
export const supportedPools = [
  {
    pid: 7,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0xe02df9e3e622debdd69fb838bb799e3f168902c5',
      [ChainId.BSC_MAINNET]: '0xe02df9e3e622debdd69fb838bb799e3f168902c5' // 主网生产
      // [ChainId.BSC_MAINNET]: '0x918DE02364E0b63CE83e3741d254D19D8FE8f914', // 主网预生产合约ODO
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'Bread',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'bread'
  },
  {
    pid: 37,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gatBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gatBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gat[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gat[ChainId.BSC_MAINNET]
    },
    name: 'GAT-BNB BLP',
    symbol: 'GAT-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'gat',
    stakeIcon: 'gat_bnb'
  },
  {
    pid: 36,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokau[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokau[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokau[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokau[ChainId.BSC_MAINNET]
    },
    name: 'TOKAU TO BAKE',
    symbol: 'TOKAU',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'tokau',
    stakeIcon: 'tokau',
    ended: true
  },
  {
    pid: 35,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokauBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokauBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokau[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokau[ChainId.BSC_MAINNET]
    },
    name: 'TOKAU-BNB BLP',
    symbol: 'TOKAU-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'tokau',
    stakeIcon: 'tokau_bnb'
  },
  {
    pid: 34,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.barkDoggyBLp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.barkDoggyBLp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.doggy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.doggy[ChainId.BSC_MAINNET]
    },
    name: 'BARK-DOGGY BLP',
    symbol: 'BARK-DOGGY BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'bark',
    stakeIcon: 'bark_doggy'
  },
  {
    pid: 33,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.doggyBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.doggyBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.doggy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.doggy[ChainId.BSC_MAINNET]
    },
    name: 'DOGGY-BNB BLP',
    symbol: 'DOGGY-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'doggy',
    stakeIcon: 'doggy_bnb'
  },
  {
    pid: 32,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.carBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.carBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.car[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.car[ChainId.BSC_MAINNET]
    },
    name: 'CAR-BNB BLP',
    symbol: 'CAR-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'car',
    stakeIcon: 'car_bnb'
  },
  {
    pid: 31,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.car[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.car[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.car[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.car[ChainId.BSC_MAINNET]
    },
    name: 'CAR TO BAKE',
    symbol: 'CAR',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'car',
    stakeIcon: 'car'
  },
  {
    pid: 1400002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tctBusdBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tctBusdBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.busd[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.busd[ChainId.BSC_MAINNET]
    },
    name: 'TCT-BUSD BLP',
    symbol: 'TCT-BUSD BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'tct',
    stakeIcon: 'tctbake'
  },
  {
    pid: 30,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pokerBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pokerBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.poker[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.poker[ChainId.BSC_MAINNET]
    },
    name: 'POKER-BNB BLP',
    symbol: 'POKER-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'poker',
    stakeIcon: 'poker_bnb'
  },
  {
    pid: 29,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.poker[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.poker[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.poker[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.poker[ChainId.BSC_MAINNET]
    },
    name: 'POKER TO BAKE',
    symbol: 'POKER',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'poker',
    stakeIcon: 'poker'
  },
  {
    pid: 28,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.xDittoBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.xDittoBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.xDitto[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.xDitto[ChainId.BSC_MAINNET]
    },
    name: 'xDitto-BNB BLP',
    symbol: 'xDitto-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'xditto',
    stakeIcon: 'xditto_bnb',
    ended: true
  },
  {
    pid: 26,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.soccerBakeBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.soccerBakeBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'SOCCER-BAKE BLP',
    symbol: 'SOCCER-BAKE BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'soccer',
    stakeIcon: 'soccerbake'
  },
  {
    pid: 25,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.soccer[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.soccer[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.soccer[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.soccer[ChainId.BSC_MAINNET]
    },
    name: 'SOCCER',
    symbol: 'SOCCER',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'soccer',
    stakeIcon: 'soccer'
  },
  {
    pid: 24,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.autoBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.autoBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.weth[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.weth[ChainId.BSC_MAINNET]
    },
    name: 'AUTO-BNB BLP',
    symbol: 'AUTO-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'auto',
    stakeIcon: 'autobnb'
  },
  {
    pid: 23,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bakeBatBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bakeBatBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAT',
    symbol: 'BAKE-BAT BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'bat',
    stakeIcon: 'bakeBat'
  },
  {
    pid: 21,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bakeMxBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bakeMxBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'MX',
    symbol: 'BAKE-MX BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'mx',
    stakeIcon: 'bakeMx',
    ended: true
  },
  {
    pid: 20,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bakeWarBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bakeWarBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'WAR',
    symbol: 'BAKE-WAR BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'war',
    ended: true
  },
  {
    pid: 19,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pCWSBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pCWSBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pCWS[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pCWS[ChainId.BSC_MAINNET]
    },
    name: 'pCWS',
    symbol: 'BNB-pCWS BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'pcws',
    ended: true
  },
  // {
  //   pid: 18,
  //   lpAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.DEFI100BakeBLP[ChainId.BSC_TESTNET], // use bake bnb
  //     [ChainId.BSC_MAINNET]: contractAddresses.DEFI100BakeBLP[ChainId.BSC_MAINNET]
  //   },
  //   tokenAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
  //     [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
  //   },
  //   name: 'D100',
  //   symbol: 'BAKE-D100 BLP',
  //   tokenSymbol: MINTTOKEN.BAKE,
  //   icon: 'defi100',
  //   ended: true
  // },
  {
    pid: 17,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.BRYBakeBLP[ChainId.BSC_TESTNET], // use bake bnb
      [ChainId.BSC_MAINNET]: contractAddresses.BRYBakeBLP[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BRY',
    symbol: 'BAKE-BRY BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'bry',
    ended: true
  },
  {
    pid: 16,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x8170b95AaCe8F494090Db7A4a17ba9EB73C2413C', // use bake bnb
      [ChainId.BSC_MAINNET]: '0x8F30114846012e5C1Fa33F32Cf93b0250C90E05a'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'SHIELD',
    symbol: 'BAKE-SHIELD BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'shield',
    ended: true
  },
  {
    pid: 14,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x8170b95AaCe8F494090Db7A4a17ba9EB73C2413C', // use bake bnb
      [ChainId.BSC_MAINNET]: '0xdb2d83eD108E68cc1C9689081d54673Bd9402A54'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'DOGE',
    symbol: 'BAKE-DOGE BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'doge.png'
  },
  {
    pid: 12,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pet[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pet[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pet[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pet[ChainId.BSC_MAINNET]
    },
    name: 'PET Staking',
    symbol: 'PET',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'pets',
    activityTime: 'Start from Oct. 23 10:00 UTC to Oct. 26 10:00 UTC',
    ended: true
  },
  {
    pid: 13,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x1699bCe1AE94fE00226329dcbBe5FE006CAF3D59',
      [ChainId.BSC_MAINNET]: '0x6F72943c807BdFaC19bAE25E84B8E99Fee0305FC'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pet[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pet[ChainId.BSC_MAINNET]
    },
    name: 'PET-BAKE BLP',
    symbol: 'PET-BAKE BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'petfood'
  },
  {
    pid: 1,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x47d34Fd4f095767E718F110AfEf030bb18E8C48F',
      [ChainId.BSC_MAINNET]: '0xc2Eed0F5a0dc28cfa895084bC0a9B8B8279aE492',
      1: '0xce84867c3c02b05dc570d0135103d3fb9cc19433'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE-BNB BLP',
    symbol: 'BAKE-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'doughnut'
  },
  {
    pid: 8,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0xF5BE5d0e9d43280408f3C8d3Cc5e2F4D55C1887E',
      [ChainId.BSC_MAINNET]: '0x6E218EA042BeF40a8baF706b00d0f0A7b4fCE50a'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE-BUSD BLP',
    symbol: 'BAKE-BUSD BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'waffle'
  },
  {
    pid: 9,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x8170b95AaCe8F494090Db7A4a17ba9EB73C2413C', // use bake bnb
      [ChainId.BSC_MAINNET]: '0x5B294814Ca563E81085a858c0e53B9F2c7a3927f'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE-DOT BLP',
    symbol: 'BAKE-DOT BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'rolls',
    ended: true
  },
  {
    pid: 2,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0xAf5e8AA68dd1b61376aC4F6fa4D06A5A4AB6cafD',
      [ChainId.BSC_MAINNET]: '0x559e3D9611E9cB8a77c11335Bdac49621382188B',
      1: '0xa5904961f61bae7c4dd8478077556c91bf291cfd'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: '0xed24fc36d5ee211ea25a80239fb8c4cfd80f12ee',
      [ChainId.BSC_MAINNET]: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
      1: '0xaba8cac6866b83ae4eec97dd07ed254282f6ad8a'
    },
    name: 'BUSD-BNB BLP',
    symbol: 'BUSD-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'croissant'
  },
  {
    pid: 10,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x05d08eAa0D769037005b529BfFCA63484A74BfB2',
      [ChainId.BSC_MAINNET]: '0xbcF3278098417E23d941613ce36a7cE9428724A5', // 主网生产
      1: '0xce84867c3c02b05dc570d0135103d3fb9cc19433'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: '0xeD24FC36d5Ee211Ea25A80239Fb8C4Cfd80f12Ee',
      [ChainId.BSC_MAINNET]: '0xe9e7cea3dedca5984780bafc599bd69add087d56', // 主网生产
      1: '0x6b3595068778dd592e39a122f4f5a5cf09c90fe2'
    },
    name: 'USDT-BUSD BLP',
    symbol: 'USDT-BUSD BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'latte'
  },
  {
    pid: 22,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.busdUsdcBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.busdUsdcBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.busd[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.busd[ChainId.BSC_MAINNET]
    },
    name: 'BUSD-USDC BLP',
    symbol: 'BUSD-USDC BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'busdUsdc'
  },
  {
    pid: 3,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x6f469DAE7F333EdfC98c6057F12E2A7521a9861c',
      [ChainId.BSC_MAINNET]: '0xa50b9c5DB61C855D5939aa1a66B26Df77745809b',
      1: '0xa5904961f61bae7c4dd8478077556c91bf291cfd'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: '0xd66c6b4f0be8ce5b39d52e0fd1344c389929b378',
      [ChainId.BSC_MAINNET]: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
      1: '0xaba8cac6866b83ae4eec97dd07ed254282f6ad8a'
    },
    name: 'ETH-BNB BLP',
    symbol: 'ETH-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'toast'
  },
  {
    pid: 4,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0xf6fD8961F129955A51ba3B392B40594B499dEF3a',
      [ChainId.BSC_MAINNET]: '0x58521373474810915b02FE968D1BCBe35Fc61E09',
      1: '0xa5904961f61bae7c4dd8478077556c91bf291cfd'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: '0x6ce8da28e2f864420840cf74474eff5fd80e65b8',
      [ChainId.BSC_MAINNET]: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
      1: '0xaba8cac6866b83ae4eec97dd07ed254282f6ad8a'
    },
    name: 'BTC-BNB BLP',
    symbol: 'BTC-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'cake'
  },
  {
    pid: 5,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x937c36B10F0a0B3aeA8a3EF0Ef9eB56E74692A84', // use btc
      [ChainId.BSC_MAINNET]: '0x56D68e3645c9A010c7fD5313530b9194Ff66C725',
      1: '0xa5904961f61bae7c4dd8478077556c91bf291cfd'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: '0x6ce8da28e2f864420840cf74474eff5fd80e65b8', // use btc
      [ChainId.BSC_MAINNET]: '0x7083609fce4d1d8dc0c979aab8c869ea2c873402',
      1: '0xaba8cac6866b83ae4eec97dd07ed254282f6ad8a'
    },
    name: 'DOT-BNB BLP',
    symbol: 'DOT-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'cookies',
    ended: true
  },
  {
    pid: 6,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x5B85218b6079524867ed3D99Bd345B873278CA4F', // use btc
      [ChainId.BSC_MAINNET]: '0x52AaEF46c9F02dBC45Ce3a55ff2B7057f5aB6275',
      1: '0xa5904961f61bae7c4dd8478077556c91bf291cfd'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: '0x6ce8da28e2f864420840cf74474eff5fd80e65b8', // use btc
      [ChainId.BSC_MAINNET]: '0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd',
      1: '0xaba8cac6866b83ae4eec97dd07ed254282f6ad8a'
    },
    name: 'LINK-BNB BLP',
    symbol: 'LINK-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'pineapple_bun',
    ended: true
  },
]

// mint bake pools
export const supportedV2Pools = [
  {
    pid: 74,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0xe02df9e3e622debdd69fb838bb799e3f168902c5',
      [ChainId.BSC_MAINNET]: '0xe02df9e3e622debdd69fb838bb799e3f168902c5' // 主网生产
      // [ChainId.BSC_MAINNET]: '0x918DE02364E0b63CE83e3741d254D19D8FE8f914', // 主网预生产合约ODO
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'Bread',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'bread'
  },
  {
    pid: 77,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.eggBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.eggBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.egg[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.egg[ChainId.BSC_MAINNET]
    },
    name: 'EGG-BNB BLP',
    symbol: 'EGG-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'egg',
    stakeIcon: 'egg_bnb'
  },
  {
    pid: 49,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x47d34Fd4f095767E718F110AfEf030bb18E8C48F',
      [ChainId.BSC_MAINNET]: '0xc2Eed0F5a0dc28cfa895084bC0a9B8B8279aE492',
      1: '0xce84867c3c02b05dc570d0135103d3fb9cc19433'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE-BNB BLP',
    symbol: 'BAKE-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'bake',
    stakeIcon: 'bake_bnb'
  },
  {
    pid: 76,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bakeBusdBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bakeBusdBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE-BUSD BLP',
    symbol: 'BAKE-BUSD BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'bake',
    stakeIcon: 'bake_busd'
  },
  {
    pid: 42,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0xf6fD8961F129955A51ba3B392B40594B499dEF3a',
      [ChainId.BSC_MAINNET]: '0x58521373474810915b02FE968D1BCBe35Fc61E09',
      1: '0xa5904961f61bae7c4dd8478077556c91bf291cfd'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: '0x6ce8da28e2f864420840cf74474eff5fd80e65b8',
      [ChainId.BSC_MAINNET]: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
      1: '0xaba8cac6866b83ae4eec97dd07ed254282f6ad8a'
    },
    name: 'BTC-BNB BLP',
    symbol: 'BTC-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'btc',
    stakeIcon: 'btc_bnb'
  },
  {
    pid: 43,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x6f469DAE7F333EdfC98c6057F12E2A7521a9861c',
      [ChainId.BSC_MAINNET]: '0xa50b9c5DB61C855D5939aa1a66B26Df77745809b',
      1: '0xa5904961f61bae7c4dd8478077556c91bf291cfd'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: '0xd66c6b4f0be8ce5b39d52e0fd1344c389929b378',
      [ChainId.BSC_MAINNET]: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
      1: '0xaba8cac6866b83ae4eec97dd07ed254282f6ad8a'
    },
    name: 'ETH-BNB BLP',
    symbol: 'ETH-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'eth',
    stakeIcon: 'eth_bnb'
  },
  {
    pid: 46,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0xAf5e8AA68dd1b61376aC4F6fa4D06A5A4AB6cafD',
      [ChainId.BSC_MAINNET]: '0x559e3D9611E9cB8a77c11335Bdac49621382188B',
      1: '0xa5904961f61bae7c4dd8478077556c91bf291cfd'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: '0xed24fc36d5ee211ea25a80239fb8c4cfd80f12ee',
      [ChainId.BSC_MAINNET]: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
      1: '0xaba8cac6866b83ae4eec97dd07ed254282f6ad8a'
    },
    name: 'BUSD-BNB BLP',
    symbol: 'BUSD-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'busd',
    stakeIcon: 'busd_bnb'
  },
  {
    pid: 73,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.usdtBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.usdtBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.usdtToken[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.usdtToken[ChainId.BSC_MAINNET]
    },
    name: 'USDT-BNB BLP',
    symbol: 'USDT-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'usdt',
    stakeIcon: 'usdt_bnb'
  },
  {
    pid: 68,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.doggyBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.doggyBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.doggy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.doggy[ChainId.BSC_MAINNET]
    },
    name: 'DOGGY-BNB BLP',
    symbol: 'DOGGY-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'doggy',
    stakeIcon: 'doggy_bnb'
  },
  {
    pid: 67,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.carBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.carBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.car[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.car[ChainId.BSC_MAINNET]
    },
    name: 'CAR-BNB BLP',
    symbol: 'CAR-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'car',
    stakeIcon: 'car_bnb'
  },
  {
    pid: 66,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.car[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.car[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.car[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.car[ChainId.BSC_MAINNET]
    },
    name: 'CAR TO BAKE',
    symbol: 'CAR',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'car',
    stakeIcon: 'car'
  },
  {
    pid: 72,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gatBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gatBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gat[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gat[ChainId.BSC_MAINNET]
    },
    name: 'GAT-BNB BLP',
    symbol: 'GAT-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'gat',
    stakeIcon: 'gat_bnb'
  },
  {
    pid: 64,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pokerBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pokerBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.poker[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.poker[ChainId.BSC_MAINNET]
    },
    name: 'POKER-BNB BLP',
    symbol: 'POKER-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'poker',
    stakeIcon: 'poker_bnb'
  },
  {
    pid: 63,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.poker[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.poker[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.poker[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.poker[ChainId.BSC_MAINNET]
    },
    name: 'POKER TO BAKE',
    symbol: 'POKER',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'poker',
    stakeIcon: 'poker'
  },
  {
    pid: 70,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokauBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokauBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokau[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokau[ChainId.BSC_MAINNET]
    },
    name: 'TOKAU-BNB BLP',
    symbol: 'TOKAU-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'tokau',
    stakeIcon: 'tokau_bnb'
  },
  {
    pid: 75,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.soccerBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.soccerBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'SOCCER-BNB BLP',
    symbol: 'SOCCER-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'soccer',
    stakeIcon: 'soccerbnb'
  },
  {
    pid: 60,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.soccer[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.soccer[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.soccer[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.soccer[ChainId.BSC_MAINNET]
    },
    name: 'SOCCER',
    symbol: 'SOCCER',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'soccer',
    stakeIcon: 'soccer'
  }
]

// new Pools下的矿池必须在pet/bake矿池中有
export const supportedNewPools = [
  {
    pid: 74,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0xe02df9e3e622debdd69fb838bb799e3f168902c5',
      [ChainId.BSC_MAINNET]: '0xe02df9e3e622debdd69fb838bb799e3f168902c5', // 主网生产
      // [ChainId.BSC_MAINNET]: '0x918DE02364E0b63CE83e3741d254D19D8FE8f914', // 主网预生产合约ODO
      1: '0xce84867c3c02b05dc570d0135103d3fb9cc19433'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'Bread',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'bread'
  },
  {
    pid: 2400001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to TLM',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.TLM,
    icon: 'tlm',
    stakeIcon: 'bake',
    otherName: 'TLM',
    decimal: 4,
    ended: true
  },
  {
    pid: 2500001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tsa[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tsa[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to TSA',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.TSA,
    icon: 'tsa',
    stakeIcon: 'bake',
    otherName: 'TSA',
    ended: true
  },
  {
    pid: 3100001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gatBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gatBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gatBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gatBnbBlp[ChainId.BSC_MAINNET]
    },
    name: 'TOY NFT POOL',
    symbol: 'GAT-BNB BLP',
    tokenSymbol: MINTTOKEN.TOYNFT,
    icon: 'toynft',
    stakeIcon: 'gatBnb',
    otherName: 'TOY NFT'
  },
  {
    pid: 3000001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.wsg[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.wsg[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to WSG',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.WSG,
    icon: 'wsg',
    stakeIcon: 'bake',
    otherName: 'WSG'
  },
  {
    pid: 3000002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.wsgBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.wsgBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.wsg[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.wsg[ChainId.BSC_MAINNET]
    },
    name: 'WSG-BNB BLP',
    symbol: 'WSG-BNB BLP',
    tokenSymbol: MINTTOKEN.WSG,
    icon: 'wsg',
    stakeIcon: 'wsg_bnb',
    otherName: 'WSG'
  },
  {
    pid: 3000003,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gat[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gat[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.wsg[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.wsg[ChainId.BSC_MAINNET]
    },
    name: 'GAT to WSG',
    symbol: 'GAT',
    tokenSymbol: MINTTOKEN.WSG,
    icon: 'wsg',
    stakeIcon: 'gat',
    otherName: 'WSG'
  },
  {
    pid: 2700009,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gat[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gat[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'GAT TO TLM',
    symbol: 'GAT',
    tokenSymbol: MINTTOKEN.TLM5,
    icon: 'gat',
    stakeIcon: 'gat',
    otherName: 'TLM',
    decimal: 4
  },
  {
    pid: 72,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gatBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gatBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gat[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gat[ChainId.BSC_MAINNET]
    },
    name: 'GAT-BNB BLP',
    symbol: 'GAT-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'gat',
    stakeIcon: 'gat_bnb'
  },
  {
    pid: 2800001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.toys[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.toys[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gat[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gat[ChainId.BSC_MAINNET]
    },
    name: 'TOY NFT to GAT',
    symbol: 'TOY NFT',
    tokenSymbol: MINTTOKEN.TOYNFTSTAKE,
    icon: 'toynft_earn',
    stakeIcon: 'toynft_earn',
    otherName: 'GAT',
    stakeType: 1,
    amountDay: 1000,
    amountUnit: 'GAT/Day'
  },
  {
    pid: 70,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokauBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokauBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokau[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokau[ChainId.BSC_MAINNET]
    },
    name: 'TOKAU-BNB BLP',
    symbol: 'TOKAU-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'tokau',
    stakeIcon: 'tokau_bnb'
  },
  {
    pid: 2700003,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.doggy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.doggy[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bondly[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bondly[ChainId.BSC_MAINNET]
    },
    name: 'DOGGY to BONDLY',
    symbol: 'DOGGY',
    tokenSymbol: MINTTOKEN.BONDLY2,
    icon: 'doggy',
    stakeIcon: 'doggy',
    otherName: 'BONDLY',
    ended: true
  },
  {
    pid: 2700001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.doggy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.doggy[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'DOGGY to TLM',
    symbol: 'DOGGY',
    tokenSymbol: MINTTOKEN.TLM2,
    icon: 'doggy',
    stakeIcon: 'doggy',
    otherName: 'TLM',
    decimal: 4
  },
  {
    pid: 68,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.doggyBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.doggyBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.doggy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.doggy[ChainId.BSC_MAINNET]
    },
    name: 'DOGGY-BNB BLP',
    symbol: 'DOGGY-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'doggy',
    stakeIcon: 'doggy_bnb'
  },
  {
    pid: 67,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.carBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.carBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.car[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.car[ChainId.BSC_MAINNET]
    },
    name: 'CAR-BNB BLP',
    symbol: 'CAR-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'car',
    stakeIcon: 'car_bnb'
  },
  {
    pid: 66,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.car[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.car[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.car[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.car[ChainId.BSC_MAINNET]
    },
    name: 'CAR TO BAKE',
    symbol: 'CAR',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'car',
    stakeIcon: 'car'
  },
  {
    pid: 64,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pokerBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pokerBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.poker[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.poker[ChainId.BSC_MAINNET]
    },
    name: 'POKER-BNB BLP',
    symbol: 'POKER-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'poker',
    stakeIcon: 'poker_bnb'
  },
  {
    pid: 63,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.poker[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.poker[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.poker[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.poker[ChainId.BSC_MAINNET]
    },
    name: 'POKER TO BAKE',
    symbol: 'POKER',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'poker',
    stakeIcon: 'poker'
  },
  {
    pid: 61,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.soccerBakeBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.soccerBakeBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'SOCCER-BAKE BLP',
    symbol: 'SOCCER-BAKE BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'soccer',
    stakeIcon: 'soccerbake'
  },
  {
    pid: 60,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.soccer[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.soccer[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.soccer[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.soccer[ChainId.BSC_MAINNET]
    },
    name: 'SOCCER',
    symbol: 'SOCCER',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'soccer',
    stakeIcon: 'soccer'
  },
  {
    pid: 2400001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to TLM',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.TLM,
    icon: 'tlm',
    stakeIcon: 'bake',
    otherName: 'TLM',
    decimal: 4
  },
  {
    pid: 1100001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bakeAliceBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bakeAliceBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.alice[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.alice[ChainId.BSC_MAINNET]
    },
    name: 'BAKE-ALICE BLP',
    symbol: 'BAKE-ALICE BLP',
    tokenSymbol: MINTTOKEN.ALICE,
    icon: 'alice',
    stakeIcon: 'alicebake',
    otherName: 'ALICE'
  },
  // {
  //   pid: 900002,
  //   lpAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.bnbDieselBlp[ChainId.BSC_TESTNET],
  //     [ChainId.BSC_MAINNET]: contractAddresses.bnbDieselBlp[ChainId.BSC_MAINNET]
  //   },
  //   tokenAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.diesel[ChainId.BSC_TESTNET],
  //     [ChainId.BSC_MAINNET]: contractAddresses.diesel[ChainId.BSC_MAINNET]
  //   },
  //   name: 'BNB-DIESEL BLP',
  //   symbol: 'BNB-DIESEL BLP',
  //   tokenSymbol: MINTTOKEN.DIESEL,
  //   icon: 'diesel',
  //   stakeIcon: 'bnb_diesel',
  //   otherName: 'DIESEL'
  // },
  // {
  //   pid: 900001,
  //   lpAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
  //     [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
  //   },
  //   tokenAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
  //     [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
  //   },
  //   name: 'BAKE to DIESEL',
  //   symbol: 'BAKE',
  //   tokenSymbol: MINTTOKEN.DIESEL,
  //   icon: 'diesel',
  //   stakeIcon: 'bake',
  //   otherName: 'DIESEL'
  // },
  {
    pid: 1800001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.petBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.petBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pet[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pet[ChainId.BSC_MAINNET]
    },
    name: 'EPET-BNB to PET',
    symbol: 'PET-BNB BLP',
    tokenSymbol: MINTTOKEN.PET3,
    icon: 'pet3',
    // activityTime: '5000 PET/hour from Oct. 20 07:00 UTC to Oct. 20 19:00 UTC',
    stakeIcon: 'bpet3',
    otherName: 'PET'
  }
]

export const supportedPetPools = [
  {
    pid: 10001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'Pet Airdrop',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.PET,
    icon: 'pets',
    activityTime: '5000 PET/hour from Oct. 20 07:00 UTC to Oct. 20 19:00 UTC',
    amountDay: 5000,
    amountUnit: 'PET/Hour',
    stakeIcon: 'bake'
  }
]

export const otherPools = [
  
  {
    pid: 4000001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokau[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokau[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokau[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokau[ChainId.BSC_MAINNET]
    },
    name: 'TOKAU to TOKAU',
    symbol: 'TOKAU',
    tokenSymbol: MINTTOKEN.TOKAU,
    icon: 'tokau',
    stakeIcon: 'tokau',
    otherName: 'TOKAU'
  },
  {
    pid: 2500001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tsa[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tsa[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to TSA',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.TSA,
    icon: 'tsa',
    stakeIcon: 'bake',
    otherName: 'TSA',
    ended: true
  },
  {
    pid: 1300001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.dfyBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.dfyBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.dfy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.dfy[ChainId.BSC_MAINNET]
    },
    name: 'DFY-BNB to DFY',
    symbol: 'DFY-BNB BLP',
    tokenSymbol: MINTTOKEN.DFY,
    icon: 'dfy',
    stakeIcon: 'bnbDfy',
    otherName: 'DFY',
    ended: true
  },
  {
    pid: 1300002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.dfyBakeBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.dfyBakeBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.dfy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.dfy[ChainId.BSC_MAINNET]
    },
    name: 'DFY-BAKE to DFY',
    symbol: 'DFY-BAKE BLP',
    tokenSymbol: MINTTOKEN.DFY,
    icon: 'dfy',
    stakeIcon: 'bakeDfy',
    otherName: 'DFY',
    ended: true
  }
]

export const endedPools = [
  {
    pid: 5100001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.nbl[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.nbl[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to NBL',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.NBL,
    icon: 'nbl',
    stakeIcon: 'bake',
    otherName: 'NBL'
  },
  {
    pid: 5100002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.nblBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.nblBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.nbl[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.nbl[ChainId.BSC_MAINNET]
    },
    name: 'NBL-BNB BLP',
    symbol: 'NBL-BNB BLP',
    tokenSymbol: MINTTOKEN.NBL,
    icon: 'nbl',
    stakeIcon: 'nbl_bnb',
    otherName: 'NBL'
  },
  {
    pid: 5000001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.kxa[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.kxa[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to KXA',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.KXA,
    icon: 'kxa',
    stakeIcon: 'bake',
    otherName: 'KXA'
  },
  {
    pid: 1700001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sactBakeBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sactBakeBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sact[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sact[ChainId.BSC_MAINNET]
    },
    name: 'SACT-BAKE to SACT',
    symbol: 'SACT-BAKE BLP',
    tokenSymbol: MINTTOKEN.SACT,
    icon: 'sact',
    stakeIcon: 'sact_bake',
    otherName: 'SACT'
  },
  {
    pid: 1100001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bakeAliceBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bakeAliceBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.alice[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.alice[ChainId.BSC_MAINNET]
    },
    name: 'BAKE-ALICE BLP',
    symbol: 'BAKE-ALICE BLP',
    tokenSymbol: MINTTOKEN.ALICE,
    icon: 'alice',
    stakeIcon: 'alicebake',
    otherName: 'ALICE'
  },
  {
    pid: 1800001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.petBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.petBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pet[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pet[ChainId.BSC_MAINNET]
    },
    name: 'EPET-BNB to PET',
    symbol: 'PET-BNB BLP',
    tokenSymbol: MINTTOKEN.PET3,
    icon: 'pet3',
    // activityTime: '5000 PET/hour from Oct. 20 07:00 UTC to Oct. 20 19:00 UTC',
    stakeIcon: 'bpet3',
    otherName: 'PET'
  },
  {
    pid: 2700006,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bark[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bark[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'BARK to TLM',
    symbol: 'BARK',
    tokenSymbol: MINTTOKEN.TLM3,
    icon: 'bark',
    stakeIcon: 'bark',
    otherName: 'TLM'
  },
  {
    pid: 11001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.petBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.petBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pet[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pet[ChainId.BSC_MAINNET]
    },
    name: 'PET-BNB to PET',
    symbol: 'PET-BNB BLP',
    tokenSymbol: MINTTOKEN.BPET,
    icon: 'pets',
    // activityTime: '5000 PET/hour from Oct. 20 07:00 UTC to Oct. 20 19:00 UTC',
    stakeIcon: 'pets',
    otherName: 'PET'
  },
  {
    pid: 4900001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.moni[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.moni[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to MONI',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.MONI,
    icon: 'moni',
    stakeIcon: 'bake',
    otherName: 'MONI'
  },
  {
    pid: 4300001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bmonc[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bmonc[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bmon[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bmon[ChainId.BSC_MAINNET]
    },
    name: 'GENESIS NFT',
    symbol: 'GENESIS NFT',
    tokenSymbol: MINTTOKEN.BMONCNFTSTAKE,
    icon: 'bmoncnft_earn',
    stakeIcon: 'bmoncnft_earn',
    otherName: 'BMON',
    stakeType: 1,
    amountDay: 6000,
    amountUnit: 'BMON/Day'
  },
  {
    pid: 2700001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.doggy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.doggy[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'DOGGY to TLM',
    symbol: 'DOGGY',
    tokenSymbol: MINTTOKEN.TLM2,
    icon: 'doggy',
    stakeIcon: 'doggy',
    otherName: 'TLM',
    decimal: 4
  },
  {
    pid: 4800001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.nt[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.nt[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to NT',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.NT,
    icon: 'nt',
    stakeIcon: 'bake',
    otherName: 'NT'
  },
  {
    pid: 23001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bethEthBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bethEthBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.beth[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.beth[ChainId.BSC_MAINNET]
    },
    name: 'BETH-ETH BLP',
    symbol: 'BETH-ETH BLP',
    tokenSymbol: MINTTOKEN.BETHMASTER,
    icon: 'hamburger',
    stakeIcon: 'hamburger',
    otherName: 'BETH'
  },
  {
    pid: 2400001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to TLM',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.TLM,
    icon: 'tlm',
    stakeIcon: 'bake',
    otherName: 'TLM',
    decimal: 4
  },
  {
    pid: 4600001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.kalata[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.kalata[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to KALATA',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.KALATA,
    icon: 'kalata',
    stakeIcon: 'bake',
    otherName: 'KALATA'
  },
  {
    pid: 4500001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.egg[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.egg[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to EGG',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.EGG,
    icon: 'egg',
    stakeIcon: 'bake',
    otherName: 'EGG'
  },
  {
    pid: 4700001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.don[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.don[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to DON',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.DON,
    icon: 'don',
    stakeIcon: 'bake',
    otherName: 'DON'
  },
  {
    pid: 4200001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bmonBusdBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bmonBusdBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bnrg[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bnrg[ChainId.BSC_MAINNET]
    },
    name: 'BMON-BUSD BLP',
    symbol: 'BMON-BUSD BLP',
    tokenSymbol: MINTTOKEN.BNRG,
    icon: 'bmon',
    stakeIcon: 'bmon_busd',
    otherName: 'BNRG'
  },
  {
    pid: 4200002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bmonBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bmonBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bnrg[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bnrg[ChainId.BSC_MAINNET]
    },
    name: 'BMON-BNB BLP',
    symbol: 'BMON-BNB BLP',
    tokenSymbol: MINTTOKEN.BNRG,
    icon: 'bmon',
    stakeIcon: 'bmon_bnb',
    otherName: 'BNRG'
  },
  {
    pid: 4400001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.dogoBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.dogoBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.dogo[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.dogo[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to DOGO',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.DOGO,
    icon: 'dogo',
    stakeIcon: 'bake',
    otherName: 'DOGO'
  },
  {
    pid: 3000001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to WSG',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.WSG,
    icon: 'wsg',
    stakeIcon: 'bake',
    otherName: 'WSG'
  },

  {
    pid: 3000002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.wsgBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.wsgBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.wsg[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.wsg[ChainId.BSC_MAINNET]
    },
    name: 'WSG-BNB BLP',
    symbol: 'WSG-BNB BLP',
    tokenSymbol: MINTTOKEN.WSG,
    icon: 'wsg',
    stakeIcon: 'wsg_bnb',
    otherName: 'WSG'
  },
  {
    pid: 3000003,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gat[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gat[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.wsg[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.wsg[ChainId.BSC_MAINNET]
    },
    name: 'GAT to WSG',
    symbol: 'GAT',
    tokenSymbol: MINTTOKEN.WSG,
    icon: 'wsg',
    stakeIcon: 'gat',
    otherName: 'WSG'
  },
  {
    pid: 2700009,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gat[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gat[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'GAT TO TLM',
    symbol: 'GAT',
    tokenSymbol: MINTTOKEN.TLM5,
    icon: 'gat',
    stakeIcon: 'gat',
    otherName: 'TLM',
    decimal: 4
  },
  {
    pid: 69,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.barkDoggyBLp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.barkDoggyBLp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.doggy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.doggy[ChainId.BSC_MAINNET]
    },
    name: 'BARK-DOGGY BLP',
    symbol: 'BARK-DOGGY BLP',
    tokenSymbol: MINTTOKEN.BAKEV2,
    otherName: 'BAKE',
    icon: 'bark',
    stakeIcon: 'bark_doggy',
  },
  {
    pid: 17001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x07b5a883c74a844232533ee8b713f5210fe15b5b',
      [ChainId.BSC_MAINNET]: '0xFb72D7C0f1643c96c197A98E5f36eBcf7597d0E3'
    },
    tokenAddresses: [
      {
        [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: '0x747c58A36Fe414032072d671ccdf38720aDDb1a9',
        [ChainId.BSC_MAINNET]: '0x250632378E573c6Be1AC2f97Fcdf00515d0Aa91B'
      }
    ],
    name: 'BETH-ETH BLP',
    symbol: 'BETH-ETH BLP',
    tokenSymbol: MINTTOKEN.ETH2MASTER,
    icon: 'hamburger',
    stakeIcon: 'eth',
    otherName: 'BAKE',
    bethRoi: 15,
    bakeRoi: 15
  },
  {
    pid: 17002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x392a2cfd11f5933fc48f6d132567bf0d8816443e',
      [ChainId.BSC_MAINNET]: '0x2fC2aD3c28560C97CAcA6D2DcF9B38614F48769A'
    },
    tokenAddresses: [
      {
        [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: '0x747c58A36Fe414032072d671ccdf38720aDDb1a9',
        [ChainId.BSC_MAINNET]: '0x250632378E573c6Be1AC2f97Fcdf00515d0Aa91B'
      }
    ],
    name: 'BETH-BNB BLP',
    symbol: 'BETH-BNB BLP',
    tokenSymbol: MINTTOKEN.ETH2MASTER,
    icon: 'macaroon',
    stakeIcon: 'eth',
    otherName: 'BAKE',
    bethRoi: 15,
    bakeRoi: 15
  },
  {
    pid: 17003,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0xa759f0fd9918bba2c03687492d5b7dc37ebd9ac9',
      [ChainId.BSC_MAINNET]: '0x5FeF671Df9718934FDa164da289374f675745D86'
    },
    tokenAddresses: [
      {
        [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: '0x747c58A36Fe414032072d671ccdf38720aDDb1a9',
        [ChainId.BSC_MAINNET]: '0x250632378E573c6Be1AC2f97Fcdf00515d0Aa91B'
      }
    ],
    name: 'BETH-BUSD BLP',
    symbol: 'BETH-BUSD BLP',
    tokenSymbol: MINTTOKEN.ETH2MASTER,
    icon: 'macaroon2',
    stakeIcon: 'eth',
    otherName: 'BAKE',
    bethRoi: 15,
    bakeRoi: 15
  },
  {
    pid: 18001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x29A96ac9949C1de0Ac9896Ae2A2229570dFd867E',
      [ChainId.BSC_MAINNET]: '0x8c7e17ebe49943109F04c85dF540609c660E2a27'
    },
    tokenAddresses: [
      {
        [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: contractAddresses.ankr[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.ankr[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: contractAddresses.onx[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.onx[ChainId.BSC_MAINNET]
      }
    ],
    name: 'aETHc-BETH BLP',
    symbol: 'aETHc-BETH BLP',
    tokenSymbol: MINTTOKEN.AETHMASTER,
    icon: 'macaroon3',
    stakeIcon: 'aeth',
    otherName: 'ANKR + ONX',
    bethRoi: 15,
    bakeRoi: 15
  },
  {
    pid: 18002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x21B712E0A15DE4b0DB343F958aDA7d6Dbc31ba59',
      [ChainId.BSC_MAINNET]: '0xcCFe31Dd6B74b2695a5163a6648d28766323EbC3'
    },
    tokenAddresses: [
      {
        [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: contractAddresses.ankr[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.ankr[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: contractAddresses.onx[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.onx[ChainId.BSC_MAINNET]
      }
    ],
    name: 'aETHc-ETH BLP',
    symbol: 'aETHc-ETH BLP',
    tokenSymbol: MINTTOKEN.AETHMASTER,
    icon: 'macaroon4',
    stakeIcon: 'aeth',
    otherName: 'ANKR + ONX',
    bethRoi: 15,
    bakeRoi: 15
  },
  {
    pid: 2900001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.liBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.liBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.lev[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.lev[ChainId.BSC_MAINNET]
    },
    name: 'LI-BNB BLP',
    symbol: 'LI-BNB BLP',
    tokenSymbol: MINTTOKEN.LEV,
    icon: 'li',
    stakeIcon: 'bnbli',
    otherName: 'LEV'
  },
  {
    pid: 2900002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.siBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.siBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.lev[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.lev[ChainId.BSC_MAINNET]
    },
    name: 'SI-BNB BLP',
    symbol: 'SI-BNB BLP',
    tokenSymbol: MINTTOKEN.LEV,
    icon: 'si',
    stakeIcon: 'bnbsi',
    otherName: 'LEV'
  },
  {
    pid: 2900003,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.levBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.levBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.lev[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.lev[ChainId.BSC_MAINNET]
    },
    name: 'LEV-BNB BLP',
    symbol: 'LEV-BNB BLP',
    tokenSymbol: MINTTOKEN.LEV,
    icon: 'lev',
    stakeIcon: 'bnblev',
    otherName: 'LEV'
  },
  {
    pid: 1600001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to xDitto',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.XDITTO,
    icon: 'xditto',
    stakeIcon: 'bake',
    otherName: 'xDitto'
  },
  {
    pid: 2700001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.doggy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.doggy[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'DOGGY to TLM',
    symbol: 'DOGGY',
    tokenSymbol: MINTTOKEN.TLM2,
    icon: 'doggy',
    stakeIcon: 'doggy',
    otherName: 'TLM',
    decimal: 4
  },
  {
    pid: 2700002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bondlyBnbBLp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bondlyBnbBLp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bondly[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bondly[ChainId.BSC_MAINNET]
    },
    name: 'BONDLY-BNB BLP',
    symbol: 'BONDLY-BNB BLP',
    tokenSymbol: MINTTOKEN.BONDLY,
    icon: 'bondly',
    stakeIcon: 'bnbbondly',
    otherName: 'BONDLY'
  },
  {
    pid: 2300001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tkoBusdBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tkoBusdBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tko[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tko[ChainId.BSC_MAINNET]
    },
    name: 'TKO-BUSD to TKO',
    symbol: 'TKO-BUSD BLP',
    tokenSymbol: MINTTOKEN.TKO2,
    icon: 'tko',
    stakeIcon: 'tko_busd',
    otherName: 'TKO'
  },
  {
    pid: 2300002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tkoBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tkoBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tko[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tko[ChainId.BSC_MAINNET]
    },
    name: 'TKO-BNB to TKO',
    symbol: 'TKO-BNB BLP',
    tokenSymbol: MINTTOKEN.TKO2,
    icon: 'tko',
    stakeIcon: 'tko_bnb',
    otherName: 'TKO'
  },
  {
    pid: 2000001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tko[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tko[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to TKO',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.TKO,
    icon: 'tko',
    stakeIcon: 'bake',
    otherName: 'TKO'
  },
  {
    pid: 2700004,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.ginuBnbBLp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.ginuBnbBLp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.ginu[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.ginu[ChainId.BSC_MAINNET]
    },
    name: 'GINU-BNB BLP',
    symbol: 'GINU-BNB BLP',
    tokenSymbol: MINTTOKEN.GINU,
    icon: 'ginu',
    stakeIcon: 'bnbginu',
    otherName: 'GINU'
  },
  {
    pid: 2700005,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.ginu[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.ginu[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.ginu[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.ginu[ChainId.BSC_MAINNET]
    },
    name: 'GINU to GINU',
    symbol: 'GINU',
    tokenSymbol: MINTTOKEN.GINU,
    icon: 'ginu',
    stakeIcon: 'ginu',
    otherName: 'GINU'
  },
  {
    pid: 2700008,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokau[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokau[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'TOKAU to TLM',
    symbol: 'TOKAU',
    tokenSymbol: MINTTOKEN.TLM4,
    icon: 'tokau',
    stakeIcon: 'tokau',
    otherName: 'TLM',
    decimal: 4
  },
  {
    pid: 36,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokau[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokau[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokau[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokau[ChainId.BSC_MAINNET]
    },
    name: 'TOKAU TO BAKE',
    symbol: 'TOKAU',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'tokau',
    stakeIcon: 'tokau'
  },
  {
    pid: 2500001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tsa[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tsa[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to TSA',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.TSA,
    icon: 'tsa',
    stakeIcon: 'bake',
    otherName: 'TSA'
  },
  {
    pid: 12002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pet[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pet[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pet[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pet[ChainId.BSC_MAINNET]
    },
    name: 'PET to Weapon',
    symbol: 'PET',
    tokenSymbol: MINTTOKEN.WEAPON,
    icon: 'pet_weapon',
    stakeIcon: 'pet'
  },
  {
    pid: 12001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to Weapon',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.WEAPON,
    icon: 'bake_weapon',
    stakeIcon: 'bake'
  },
  {
    pid: 2700003,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.doggy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.doggy[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bondly[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bondly[ChainId.BSC_MAINNET]
    },
    name: 'DOGGY to BONDLY',
    symbol: 'DOGGY',
    tokenSymbol: MINTTOKEN.BONDLY2,
    icon: 'doggy',
    stakeIcon: 'doggy',
    otherName: 'BONDLY'
  },
  {
    pid: 28,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.xDittoBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.xDittoBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.xDitto[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.xDitto[ChainId.BSC_MAINNET]
    },
    name: 'xDitto-BNB BLP',
    symbol: 'xDitto-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'xditto',
    stakeIcon: 'xditto_bnb'
  },
  {
    pid: 21,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bakeMxBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bakeMxBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'MX',
    symbol: 'BAKE-MX BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'mx',
    stakeIcon: 'bakeMx'
  },
  {
    pid: 20,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bakeWarBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bakeWarBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'WAR',
    symbol: 'BAKE-WAR BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'war'
  },
  {
    pid: 19,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pCWSBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pCWSBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pCWS[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pCWS[ChainId.BSC_MAINNET]
    },
    name: 'pCWS',
    symbol: 'BNB-pCWS BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'pcws'
  },
  // {
  //   pid: 18,
  //   lpAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.DEFI100BakeBLP[ChainId.BSC_TESTNET], // use bake bnb
  //     [ChainId.BSC_MAINNET]: contractAddresses.DEFI100BakeBLP[ChainId.BSC_MAINNET]
  //   },
  //   tokenAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
  //     [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
  //   },
  //   name: 'D100',
  //   symbol: 'BAKE-D100 BLP',
  //   tokenSymbol: MINTTOKEN.BAKE,
  //   icon: 'defi100'
  // },
  {
    pid: 17,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.BRYBakeBLP[ChainId.BSC_TESTNET], // use bake bnb
      [ChainId.BSC_MAINNET]: contractAddresses.BRYBakeBLP[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BRY',
    symbol: 'BAKE-BRY BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'bry'
  },
  {
    pid: 16,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x8170b95AaCe8F494090Db7A4a17ba9EB73C2413C', // use bake bnb
      [ChainId.BSC_MAINNET]: '0x8F30114846012e5C1Fa33F32Cf93b0250C90E05a'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'SHIELD',
    symbol: 'BAKE-SHIELD BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'shield'
  },
  {
    pid: 1300001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.dfyBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.dfyBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.dfy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.dfy[ChainId.BSC_MAINNET]
    },
    name: 'DFY-BNB to DFY',
    symbol: 'DFY-BNB BLP',
    tokenSymbol: MINTTOKEN.DFY,
    icon: 'dfy',
    stakeIcon: 'bnbDfy',
    otherName: 'DFY'
  },
  {
    pid: 1300002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.dfyBakeBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.dfyBakeBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.dfy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.dfy[ChainId.BSC_MAINNET]
    },
    name: 'DFY-BAKE to DFY',
    symbol: 'DFY-BAKE BLP',
    tokenSymbol: MINTTOKEN.DFY,
    icon: 'dfy',
    stakeIcon: 'bakeDfy',
    otherName: 'DFY'
  },
  {
    pid: 1400001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to TCT',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.TCT,
    icon: 'tct',
    stakeIcon: 'bake',
    otherName: 'TCT'
  },
  {
    pid: 1500001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to GFX',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.GFX,
    icon: 'gfx',
    stakeIcon: 'bake',
    otherName: 'GFX'
  },
  {
    pid: 1500002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gfxBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gfxBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gfx[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gfx[ChainId.BSC_MAINNET]
    },
    name: 'GFX-BNB to GFX',
    symbol: 'GFX-BNB BLP',
    tokenSymbol: MINTTOKEN.GFX,
    icon: 'gfx',
    stakeIcon: 'bnb_gfx',
    otherName: 'GFX'
  },
  {
    pid: 1900001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.hyfiBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.hyfiBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.hyfi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.hyfi[ChainId.BSC_MAINNET]
    },
    name: 'HYFI-BNB to HYFI',
    symbol: 'HYFI-BNB BLP',
    tokenSymbol: MINTTOKEN.HYFI,
    icon: 'hyfi',
    stakeIcon: 'bhyfi',
    otherName: 'HYFI'
  },
  {
    pid: 1900002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.hyfi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.hyfi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to HYFI',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.HYFI,
    icon: 'hyfi',
    stakeIcon: 'bake',
    otherName: 'HYFI'
  },
  {
    pid: 900001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to DIESEL',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.DIESEL,
    icon: 'diesel',
    stakeIcon: 'bake',
    otherName: 'DIESEL'
  },
  {
    pid: 900002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bnbDieselBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bnbDieselBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.diesel[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.diesel[ChainId.BSC_MAINNET]
    },
    name: 'BNB-DIESEL BLP',
    symbol: 'BNB-DIESEL BLP',
    tokenSymbol: MINTTOKEN.DIESEL,
    icon: 'diesel',
    stakeIcon: 'bnb_diesel',
    otherName: 'DIESEL'
  },
  {
    pid: 1000001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to MX',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.MX,
    icon: 'mx',
    stakeIcon: 'bake',
    otherName: 'MX'
  },
  {
    pid: 500001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to pCWS',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.PCWS,
    icon: 'pcws',
    stakeIcon: 'bake',
    otherName: 'pCWS'
  },
  {
    pid: 600001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to WAR',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.WAR,
    icon: 'war',
    stakeIcon: 'bake',
    otherName: 'WAR'
  },
  {
    pid: 700001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BUSD-WAR BLP',
    symbol: 'BUSD-WAR BLP',
    tokenSymbol: MINTTOKEN.WAR2,
    icon: 'war',
    stakeIcon: 'bake',
    otherName: 'WAR'
  },
  {
    pid: 300001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bakeBananaBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bakeBananaBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.BANANA[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.BANANA[ChainId.BSC_MAINNET]
    },
    name: 'BANANA',
    symbol: 'BAKE BANANA BLP',
    tokenSymbol: MINTTOKEN.BANANA,
    icon: 'banana',
    stakeIcon: 'banana',
    otherName: 'BANANA'
  },
  {
    pid: 22001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to BRY',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.BRY,
    icon: 'bry',
    stakeIcon: 'bake',
    otherName: 'BRY'
  },
  // {
  //   pid: 100001,
  //   lpAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
  //     [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
  //   },
  //   tokenAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
  //     [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
  //   },
  //   name: 'D100(not used) ',
  //   symbol: 'BAKE',
  //   tokenSymbol: MINTTOKEN.DEFI100,
  //   icon: 'defi100',
  //   stakeIcon: 'bake',
  //   otherName: 'D100'
  // },
  // {
  //   pid: 200001,
  //   lpAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
  //     [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
  //   },
  //   tokenAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
  //     [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
  //   },
  //   name: 'D100(not used)',
  //   symbol: 'BAKE',
  //   tokenSymbol: MINTTOKEN.DEFI100OLD,
  //   icon: 'defi100',
  //   stakeIcon: 'bake',
  //   otherName: 'D100'
  // },
  {
    pid: 21001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to SHIELD',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.SHIELD,
    icon: 'shield',
    stakeIcon: 'bake',
    otherName: 'SHIELD'
  },
  {
    pid: 20001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to wSOTE',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.WSOTE,
    icon: 'wsote',
    stakeIcon: 'bake',
    otherName: 'wSOTE'
  },
  {
    pid: 19001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tenBakeBLP[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tenBakeBLP[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.ten[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.ten[ChainId.BSC_MAINNET]
    },
    name: 'Bake to Ten',
    symbol: 'TEN-BAKE BLP',
    tokenSymbol: MINTTOKEN.TEN,
    icon: 'ten1',
    stakeIcon: 'staketen',
    otherName: 'TEN'
  },
  {
    pid: 12,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pet[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pet[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pet[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pet[ChainId.BSC_MAINNET]
    },
    name: 'PET Staking',
    symbol: 'PET',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'pets',
    activityTime: 'Start from Oct. 23 10:00 UTC to Oct. 26 10:00 UTC'
  },
  {
    pid: 10001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'Pet Airdrop',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.PET,
    icon: 'pets',
    activityTime: '5000 PET/hour from Oct. 20 07:00 UTC to Oct. 20 19:00 UTC',
    amountDay: 5000,
    amountUnit: 'PET/Hour',
    stakeIcon: 'bake'
  },
  {
    pid: 5,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x937c36B10F0a0B3aeA8a3EF0Ef9eB56E74692A84', // use btc
      [ChainId.BSC_MAINNET]: '0x56D68e3645c9A010c7fD5313530b9194Ff66C725',
      1: '0xa5904961f61bae7c4dd8478077556c91bf291cfd'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: '0x6ce8da28e2f864420840cf74474eff5fd80e65b8', // use btc
      [ChainId.BSC_MAINNET]: '0x7083609fce4d1d8dc0c979aab8c869ea2c873402',
      1: '0xaba8cac6866b83ae4eec97dd07ed254282f6ad8a'
    },
    name: 'DOT-BNB BLP',
    symbol: 'DOT-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'cookies'
  },
  {
    pid: 6,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x5B85218b6079524867ed3D99Bd345B873278CA4F', // use btc
      [ChainId.BSC_MAINNET]: '0x52AaEF46c9F02dBC45Ce3a55ff2B7057f5aB6275',
      1: '0xa5904961f61bae7c4dd8478077556c91bf291cfd'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: '0x6ce8da28e2f864420840cf74474eff5fd80e65b8', // use btc
      [ChainId.BSC_MAINNET]: '0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd',
      1: '0xaba8cac6866b83ae4eec97dd07ed254282f6ad8a'
    },
    name: 'LINK-BNB BLP',
    symbol: 'LINK-BNB BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'pineapple_bun'
  },
  {
    pid: 9,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x8170b95AaCe8F494090Db7A4a17ba9EB73C2413C', // use bake bnb
      [ChainId.BSC_MAINNET]: '0x5B294814Ca563E81085a858c0e53B9F2c7a3927f'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE-DOT BLP',
    symbol: 'BAKE-DOT BLP',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'rolls'
  },
  {
    pid: 13001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to BEST',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.BEST,
    icon: 'bake_best',
    amountDay: 5000,
    amountUnit: 'BEST',
    stakeIcon: 'bake'
  }
]

export const nftStakingPools = [
  {
    pid: 2800001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.toys[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.toys[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gat[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gat[ChainId.BSC_MAINNET]
    },
    name: 'TOY NFT to GAT',
    symbol: 'TOY NFT',
    tokenSymbol: MINTTOKEN.TOYNFTSTAKE,
    icon: 'toynft_earn',
    stakeIcon: 'toynft_earn',
    otherName: 'GAT',
    stakeType: 1,
    amountDay: 1000,
    amountUnit: 'GAT/Day'
  },
  {
    pid: 2100001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokocryptoNft[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokocryptoNft[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tko[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tko[ChainId.BSC_MAINNET]
    },
    name: 'TKO NFT to TKO',
    symbol: 'TKO NFT',
    tokenSymbol: MINTTOKEN.TKONFTSTAKE,
    icon: 'tkonft_earn',
    stakeIcon: 'tkonft_earn',
    otherName: 'TKO',
    stakeType: 1,
    amountDay: 300,
    amountUnit: 'TKO/Day'
  }
]

export const bPetPools = [
  {
    pid: 11001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.petBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.petBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pet[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pet[ChainId.BSC_MAINNET]
    },
    name: 'PET-BNB to PET',
    symbol: 'PET-BNB BLP',
    tokenSymbol: MINTTOKEN.BPET,
    icon: 'pets',
    // activityTime: '5000 PET/hour from Oct. 20 07:00 UTC to Oct. 20 19:00 UTC',
    stakeIcon: 'pets',
    otherName: 'PET'
  }
]

export const weaponPools = [
  {
    pid: 12001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to Weapon',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.WEAPON,
    icon: 'bake_weapon',
    stakeIcon: 'bake'
  },
  {
    pid: 12002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pet[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pet[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pet[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pet[ChainId.BSC_MAINNET]
    },
    name: 'PET to Weapon',
    symbol: 'PET',
    tokenSymbol: MINTTOKEN.WEAPON,
    icon: 'pet_weapon',
    stakeIcon: 'pet'
  }
]

export const bestPools = [
  {
    pid: 13001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to BEST',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.BEST,
    icon: 'bake_best',
    amountDay: 5000,
    amountUnit: 'BEST',
    stakeIcon: 'bake'
  }
]

export const weaponnftPools = [
  {
    pid: 14001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'Weapon NFT',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.WEAPONNFT,
    icon: 'weaponnft',
    stakeIcon: 'weaponnft',
    otherName: 'Weapon NFT'
  }
]

export const petNftPools = [
  {
    pid: 15001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to Pet NFT',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.PETNFT,
    icon: 'weaponnft',
    stakeIcon: 'weaponnft',
    otherName: 'Pet NFT'
  },
  {
    pid: 15002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pet[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pet[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pet[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pet[ChainId.BSC_MAINNET]
    },
    name: 'PET to Pet NFT',
    symbol: 'PET',
    tokenSymbol: MINTTOKEN.PETNFT,
    icon: 'weaponnft',
    stakeIcon: 'pet',
    otherName: 'Pet NFT'
  }
]

// earn nft
export const helmetNftPools = [
  {
    pid: 3100001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gatBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gatBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gatBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gatBnbBlp[ChainId.BSC_MAINNET]
    },
    name: 'TOY NFT POOL',
    symbol: 'GAT-BNB BLP',
    tokenSymbol: MINTTOKEN.TOYNFT,
    icon: 'toynft',
    stakeIcon: 'gatBnb',
    otherName: 'TOY NFT'
  },
  {
    pid: 2700007,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bondly[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bondly[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bondly[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bondly[ChainId.BSC_MAINNET]
    },
    name: 'BONDLY NFT Pool',
    symbol: 'BONDLY',
    tokenSymbol: MINTTOKEN.BONDLYNFT,
    icon: 'bondly',
    stakeIcon: 'bondly',
    otherName: 'BONDLY NFT'
  },
  {
    pid: 2600001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.xDitto[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.xDitto[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.xDitto[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.xDitto[ChainId.BSC_MAINNET]
    },
    name: 'DITTO NFT Pool',
    symbol: 'XDITTO',
    tokenSymbol: MINTTOKEN.XDITTONFT,
    icon: 'ditto',
    stakeIcon: 'xditto',
    otherName: 'DITTO NFT'
  },
  {
    pid: 2200001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.oneInch[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.oneInch[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.oneInch[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.oneInch[ChainId.BSC_MAINNET]
    },
    name: '1INCH NFT Pool',
    symbol: '1INCH',
    tokenSymbol: MINTTOKEN.ONEINCHBAKENFT,
    icon: '1inch',
    stakeIcon: '1inch',
    otherName: '1INCH NFT'
  },
  {
    pid: 1200001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.alice[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.alice[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.alice[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.alice[ChainId.BSC_MAINNET]
    },
    name: 'ALICE NFT Pool',
    symbol: 'ALICE',
    tokenSymbol: MINTTOKEN.ALICENFT,
    icon: 'alice',
    stakeIcon: 'alice',
    otherName: 'ALICE NFT'
  },
  {
    pid: 800001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'TKO NFT Pool',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.TKONFT,
    icon: 'tkonft',
    stakeIcon: 'bake',
    otherName: 'TKO NFT'
  },
  {
    pid: 400001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pCWS[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pCWS[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pCWS[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pCWS[ChainId.BSC_MAINNET]
    },
    name: 'CWS NFT Pool',
    symbol: 'pCWS',
    tokenSymbol: MINTTOKEN.SEASCAPENFT,
    icon: 'seascapenft',
    stakeIcon: 'helmetnft',
    otherName: 'SEASCAPE NFT'
  },
  {
    pid: 16001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'NFT Christmas Hat',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.HATNFT,
    icon: 'helmetnft',
    stakeIcon: 'helmetnft',
    otherName: 'Xmas hats NFT'
  },
  {
    pid: 19002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.ten[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.ten[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.ten[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.ten[ChainId.BSC_MAINNET]
    },
    name: 'Ten to PET NFT',
    symbol: 'TEN',
    tokenSymbol: MINTTOKEN.TEN,
    icon: 'ten2',
    stakeIcon: 'helmetnft',
    otherName: 'PET NFT',
    amountUnit: 'PET NFT',
    amountDay: '100'
  }
]

// all nft
export const allNftPools = [
  {
    pid: 4300001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bmonc[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bmonc[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bmon[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bmon[ChainId.BSC_MAINNET]
    },
    name: 'GENESIS NFT',
    symbol: 'GENESIS NFT',
    tokenSymbol: MINTTOKEN.BMONCNFTSTAKE,
    icon: 'bmoncnft_earn',
    stakeIcon: 'bmoncnft_earn',
    otherName: 'BMON',
    stakeType: 1,
    amountDay: 6000,
    amountUnit: 'BMON/Day'
  },
  {
    pid: 3100001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gatBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gatBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gatBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gatBnbBlp[ChainId.BSC_MAINNET]
    },
    name: 'TOY NFT POOL',
    symbol: 'GAT-BNB BLP',
    tokenSymbol: MINTTOKEN.TOYNFT,
    icon: 'toynft',
    stakeIcon: 'gatBnb',
    otherName: 'TOY NFT'
  },
  {
    pid: 2800001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.toys[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.toys[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gat[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gat[ChainId.BSC_MAINNET]
    },
    name: 'TOY NFT to GAT',
    symbol: 'TOY NFT',
    tokenSymbol: MINTTOKEN.TOYNFTSTAKE,
    icon: 'toynft_earn',
    stakeIcon: 'toynft_earn',
    otherName: 'GAT',
    stakeType: 1,
    amountDay: 1000,
    amountUnit: 'GAT/Day'
  },
  {
    pid: 2700007,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bondly[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bondly[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bondly[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bondly[ChainId.BSC_MAINNET]
    },
    name: 'BONDLY NFT Pool',
    symbol: 'BONDLY',
    tokenSymbol: MINTTOKEN.BONDLYNFT,
    icon: 'bondly',
    stakeIcon: 'bondly',
    otherName: 'BONDLY NFT'
  },
  {
    pid: 2600001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.xDitto[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.xDitto[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.xDitto[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.xDitto[ChainId.BSC_MAINNET]
    },
    name: 'DITTO NFT Pool',
    symbol: 'XDITTO',
    tokenSymbol: MINTTOKEN.XDITTONFT,
    icon: 'ditto',
    stakeIcon: 'xditto',
    otherName: 'DITTO NFT'
  },
  {
    pid: 2200001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.oneInch[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.oneInch[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.oneInch[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.oneInch[ChainId.BSC_MAINNET]
    },
    name: '1INCH NFT Pool',
    symbol: '1INCH',
    tokenSymbol: MINTTOKEN.ONEINCHBAKENFT,
    icon: '1inch',
    stakeIcon: '1inch',
    otherName: '1INCH NFT'
  },
  {
    pid: 1200001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.alice[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.alice[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.alice[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.alice[ChainId.BSC_MAINNET]
    },
    name: 'ALICE NFT Pool',
    symbol: 'ALICE',
    tokenSymbol: MINTTOKEN.ALICENFT,
    icon: 'alice',
    stakeIcon: 'alice',
    otherName: 'ALICE NFT'
  },
  {
    pid: 800001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'TKO NFT Pool',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.TKONFT,
    icon: 'tkonft',
    stakeIcon: 'bake',
    otherName: 'TKO NFT'
  },
  {
    pid: 400001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pCWS[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pCWS[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pCWS[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pCWS[ChainId.BSC_MAINNET]
    },
    name: 'CWS NFT Pool',
    symbol: 'pCWS',
    tokenSymbol: MINTTOKEN.SEASCAPENFT,
    icon: 'seascapenft',
    stakeIcon: 'helmetnft',
    otherName: 'SEASCAPE NFT'
  },
  {
    pid: 16001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'NFT Christmas Hat',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.HATNFT,
    icon: 'helmetnft',
    stakeIcon: 'helmetnft',
    otherName: 'Xmas hats NFT'
  },
  {
    pid: 19002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.ten[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.ten[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.ten[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.ten[ChainId.BSC_MAINNET]
    },
    name: 'Ten to PET NFT',
    symbol: 'TEN',
    tokenSymbol: MINTTOKEN.TEN,
    icon: 'ten2',
    stakeIcon: 'helmetnft',
    otherName: 'PET NFT',
    amountUnit: 'PET NFT',
    amountDay: '100'
  },
  {
    pid: 2100001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokocryptoNft[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokocryptoNft[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tko[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tko[ChainId.BSC_MAINNET]
    },
    name: 'TKO NFT to TKO',
    symbol: 'TKO NFT',
    tokenSymbol: MINTTOKEN.TKONFTSTAKE,
    icon: 'tkonft_earn',
    stakeIcon: 'tkonft_earn',
    otherName: 'TKO',
    stakeType: 1,
    amountDay: 300,
    amountUnit: 'TKO/Day'
  }
]

export const hatNftPools = [
  {
    pid: 16001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'NFT Christmas Hat',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.HATNFT,
    icon: 'helmetnft',
    stakeIcon: 'helmetnft',
    otherName: 'Xmas hats NFT'
  }
]

export const eth2MasterPools = [
  {
    pid: 17001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x07b5a883c74a844232533ee8b713f5210fe15b5b',
      [ChainId.BSC_MAINNET]: '0xFb72D7C0f1643c96c197A98E5f36eBcf7597d0E3'
    },
    tokenAddresses: [
      {
        [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: '0x747c58A36Fe414032072d671ccdf38720aDDb1a9',
        [ChainId.BSC_MAINNET]: '0x250632378E573c6Be1AC2f97Fcdf00515d0Aa91B'
      }
    ],
    name: 'BETH-ETH BLP',
    symbol: 'BETH-ETH BLP',
    tokenSymbol: MINTTOKEN.ETH2MASTER,
    icon: 'hamburger',
    stakeIcon: 'eth',
    otherName: 'BAKE',
    bethRoi: 15,
    bakeRoi: 15
  },
  {
    pid: 17002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x392a2cfd11f5933fc48f6d132567bf0d8816443e',
      [ChainId.BSC_MAINNET]: '0x2fC2aD3c28560C97CAcA6D2DcF9B38614F48769A'
    },
    tokenAddresses: [
      {
        [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: '0x747c58A36Fe414032072d671ccdf38720aDDb1a9',
        [ChainId.BSC_MAINNET]: '0x250632378E573c6Be1AC2f97Fcdf00515d0Aa91B'
      }
    ],
    name: 'BETH-BNB BLP',
    symbol: 'BETH-BNB BLP',
    tokenSymbol: MINTTOKEN.ETH2MASTER,
    icon: 'macaroon',
    stakeIcon: 'eth',
    otherName: 'BAKE',
    bethRoi: 15,
    bakeRoi: 15
  },
  {
    pid: 17003,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0xa759f0fd9918bba2c03687492d5b7dc37ebd9ac9',
      [ChainId.BSC_MAINNET]: '0x5FeF671Df9718934FDa164da289374f675745D86'
    },
    tokenAddresses: [
      {
        [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: '0x747c58A36Fe414032072d671ccdf38720aDDb1a9',
        [ChainId.BSC_MAINNET]: '0x250632378E573c6Be1AC2f97Fcdf00515d0Aa91B'
      }
    ],
    name: 'BETH-BUSD BLP',
    symbol: 'BETH-BUSD BLP',
    tokenSymbol: MINTTOKEN.ETH2MASTER,
    icon: 'macaroon2',
    stakeIcon: 'eth',
    otherName: 'BAKE',
    bethRoi: 15,
    bakeRoi: 15
  }
]

export const aethMasterPools = [
  {
    pid: 18001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x29A96ac9949C1de0Ac9896Ae2A2229570dFd867E',
      [ChainId.BSC_MAINNET]: '0x8c7e17ebe49943109F04c85dF540609c660E2a27'
    },
    tokenAddresses: [
      {
        [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: contractAddresses.ankr[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.ankr[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: contractAddresses.onx[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.onx[ChainId.BSC_MAINNET]
      }
    ],
    name: 'aETHc-BETH BLP',
    symbol: 'aETHc-BETH BLP',
    tokenSymbol: MINTTOKEN.AETHMASTER,
    icon: 'macaroon3',
    stakeIcon: 'aeth',
    otherName: 'ANKR + ONX',
    bethRoi: 15,
    bakeRoi: 15
  },
  {
    pid: 18002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x21B712E0A15DE4b0DB343F958aDA7d6Dbc31ba59',
      [ChainId.BSC_MAINNET]: '0xcCFe31Dd6B74b2695a5163a6648d28766323EbC3'
    },
    tokenAddresses: [
      {
        [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: contractAddresses.ankr[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.ankr[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: contractAddresses.onx[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.onx[ChainId.BSC_MAINNET]
      }
    ],
    name: 'aETHc-ETH BLP',
    symbol: 'aETHc-ETH BLP',
    tokenSymbol: MINTTOKEN.AETHMASTER,
    icon: 'macaroon4',
    stakeIcon: 'aeth',
    otherName: 'ANKR + ONX',
    bethRoi: 15,
    bakeRoi: 15
  }
]

export const bethMasterPools = [
  {
    pid: 23001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bethEthBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bethEthBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.beth[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.beth[ChainId.BSC_MAINNET]
    },
    name: 'BETH-ETH BLP',
    symbol: 'BETH-ETH BLP',
    tokenSymbol: MINTTOKEN.BETHMASTER,
    icon: 'hamburger',
    stakeIcon: 'hamburger',
    otherName: 'BETH'
  }
]

export const aethAndEth2Pools = [
  {
    pid: 23001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bethEthBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bethEthBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: [{
      [ChainId.BSC_TESTNET]: contractAddresses.beth[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.beth[ChainId.BSC_MAINNET]
    }],
    name: 'BETH-ETH BLP',
    symbol: 'BETH-ETH BLP',
    tokenSymbol: MINTTOKEN.BETHMASTER,
    icon: 'hamburger',
    stakeIcon: 'hamburger',
    otherName: 'BETH'
  },
  {
    pid: 17001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x07b5a883c74a844232533ee8b713f5210fe15b5b',
      [ChainId.BSC_MAINNET]: '0xFb72D7C0f1643c96c197A98E5f36eBcf7597d0E3'
    },
    tokenAddresses: [
      {
        [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: '0x747c58A36Fe414032072d671ccdf38720aDDb1a9',
        [ChainId.BSC_MAINNET]: '0x250632378E573c6Be1AC2f97Fcdf00515d0Aa91B'
      }
    ],
    name: 'BETH-ETH BLP',
    symbol: 'BETH-ETH BLP',
    tokenSymbol: MINTTOKEN.ETH2MASTER,
    icon: 'hamburger',
    stakeIcon: 'eth',
    otherName: 'BAKE',
    bethRoi: 15,
    bakeRoi: 15
  },
  {
    pid: 17002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x392a2cfd11f5933fc48f6d132567bf0d8816443e',
      [ChainId.BSC_MAINNET]: '0x2fC2aD3c28560C97CAcA6D2DcF9B38614F48769A'
    },
    tokenAddresses: [
      {
        [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: '0x747c58A36Fe414032072d671ccdf38720aDDb1a9',
        [ChainId.BSC_MAINNET]: '0x250632378E573c6Be1AC2f97Fcdf00515d0Aa91B'
      }
    ],
    name: 'BETH-BNB BLP',
    symbol: 'BETH-BNB BLP',
    tokenSymbol: MINTTOKEN.ETH2MASTER,
    icon: 'macaroon',
    stakeIcon: 'eth',
    otherName: 'BAKE',
    bethRoi: 15,
    bakeRoi: 15
  },
  {
    pid: 17003,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0xa759f0fd9918bba2c03687492d5b7dc37ebd9ac9',
      [ChainId.BSC_MAINNET]: '0x5FeF671Df9718934FDa164da289374f675745D86'
    },
    tokenAddresses: [
      {
        [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: '0x747c58A36Fe414032072d671ccdf38720aDDb1a9',
        [ChainId.BSC_MAINNET]: '0x250632378E573c6Be1AC2f97Fcdf00515d0Aa91B'
      }
    ],
    name: 'BETH-BUSD BLP',
    symbol: 'BETH-BUSD BLP',
    tokenSymbol: MINTTOKEN.ETH2MASTER,
    icon: 'macaroon2',
    stakeIcon: 'eth',
    otherName: 'BAKE',
    bethRoi: 15,
    bakeRoi: 15
  },
  {
    pid: 18001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x29A96ac9949C1de0Ac9896Ae2A2229570dFd867E',
      [ChainId.BSC_MAINNET]: '0x8c7e17ebe49943109F04c85dF540609c660E2a27'
    },
    tokenAddresses: [
      {
        [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: contractAddresses.ankr[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.ankr[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: contractAddresses.onx[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.onx[ChainId.BSC_MAINNET]
      }
    ],
    name: 'aETHc-BETH BLP',
    symbol: 'aETHc-BETH BLP',
    tokenSymbol: MINTTOKEN.AETHMASTER,
    icon: 'macaroon3',
    stakeIcon: 'aeth',
    otherName: 'ANKR + ONX',
    bethRoi: 15,
    bakeRoi: 15
  },
  {
    pid: 18002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0x21B712E0A15DE4b0DB343F958aDA7d6Dbc31ba59',
      [ChainId.BSC_MAINNET]: '0xcCFe31Dd6B74b2695a5163a6648d28766323EbC3'
    },
    tokenAddresses: [
      {
        [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: contractAddresses.ankr[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.ankr[ChainId.BSC_MAINNET]
      },
      {
        [ChainId.BSC_TESTNET]: contractAddresses.onx[ChainId.BSC_TESTNET],
        [ChainId.BSC_MAINNET]: contractAddresses.onx[ChainId.BSC_MAINNET]
      }
    ],
    name: 'aETHc-ETH BLP',
    symbol: 'aETHc-ETH BLP',
    tokenSymbol: MINTTOKEN.AETHMASTER,
    icon: 'macaroon4',
    stakeIcon: 'aeth',
    otherName: 'ANKR + ONX',
    bethRoi: 15,
    bakeRoi: 15
  }
]

export const springMasterPools = [
  {
    pid: 19001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tenBakeBLP[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tenBakeBLP[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.ten[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.ten[ChainId.BSC_MAINNET]
    },
    name: 'Bake to Ten',
    symbol: 'TEN-BAKE BLP',
    tokenSymbol: MINTTOKEN.TEN,
    icon: 'ten1',
    stakeIcon: 'staketen',
    otherName: 'TEN'
    // amountDay: '5000',
    // amountUnit: MINTTOKEN.TEN,
  },
  {
    pid: 19002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.ten[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.ten[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.ten[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.ten[ChainId.BSC_MAINNET]
    },
    name: 'Ten to PET NFT',
    symbol: 'TEN',
    tokenSymbol: MINTTOKEN.TEN,
    icon: 'ten2',
    stakeIcon: 'helmetnft',
    otherName: 'PET NFT',
    amountUnit: 'PET NFT',
    amountDay: '100'
  }
]

export const wSOTEMasterPools = [
  {
    pid: 20001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to wSOTE',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.WSOTE,
    icon: 'wsote',
    stakeIcon: 'bake',
    otherName: 'wSOTE'
  }
]

export const SHIELDMasterPools = [
  {
    pid: 21001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to SHIELD',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.SHIELD,
    icon: 'shield',
    stakeIcon: 'bake',
    otherName: 'SHIELD'
  }
]

export const BRYMasterPools = [
  {
    pid: 22001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to BRY',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.BRY,
    icon: 'bry',
    stakeIcon: 'bake',
    otherName: 'BRY'
  }
]

// bake staking
export const supportedBakeStakingPools = [
  {
    pid: 7,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: '0xe02df9e3e622debdd69fb838bb799e3f168902c5',
      [ChainId.BSC_MAINNET]: '0xe02df9e3e622debdd69fb838bb799e3f168902c5', // 主网生产
      // [ChainId.BSC_MAINNET]: '0x918DE02364E0b63CE83e3741d254D19D8FE8f914', // 主网预生产合约ODO
      1: '0xce84867c3c02b05dc570d0135103d3fb9cc19433'
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'Bread',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.BAKE,
    icon: 'bread'
  },
  {
    pid: 3000001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to WSG',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.WSG,
    icon: 'wsg',
    stakeIcon: 'bake',
    otherName: 'WSG'
  },
  {
    pid: 2400001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to TLM',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.TLM,
    icon: 'tlm',
    stakeIcon: 'bake',
    otherName: 'TLM',
    decimal: 4
  },
  {
    pid: 2500001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tsa[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tsa[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to TSA',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.TSA,
    icon: 'tsa',
    stakeIcon: 'bake',
    otherName: 'TSA',
    ended: true
  }
  // {
  //   pid: 900001,
  //   lpAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
  //     [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
  //   },
  //   tokenAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
  //     [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
  //   },
  //   name: 'BAKE to DIESEL',
  //   symbol: 'BAKE',
  //   tokenSymbol: MINTTOKEN.DIESEL,
  //   icon: 'diesel',
  //   stakeIcon: 'bake',
  //   otherName: 'DIESEL'
  // }
]

export const DEFI100MasterPools = [
  // {
  //   pid: 100001,
  //   lpAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
  //     [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
  //   },
  //   tokenAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
  //     [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
  //   },
  //   name: 'D100(not used) ',
  //   symbol: 'BAKE',
  //   tokenSymbol: MINTTOKEN.DEFI100,
  //   icon: 'defi100',
  //   stakeIcon: 'bake',
  //   otherName: 'D100'
  // }
]

export const DEFI100OLDMasterPools = [
  // {
  //   pid: 200001,
  //   lpAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
  //     [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
  //   },
  //   tokenAddresses: {
  //     [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
  //     [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
  //   },
  //   name: 'D100(not used)',
  //   symbol: 'BAKE',
  //   tokenSymbol: MINTTOKEN.DEFI100OLD,
  //   icon: 'defi100',
  //   stakeIcon: 'bake',
  //   otherName: 'D100'
  // }
]

export const BananaMasterPools = [
  {
    pid: 300001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bakeBananaBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bakeBananaBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.BANANA[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.BANANA[ChainId.BSC_MAINNET]
    },
    name: 'BANANA',
    symbol: 'BAKE BANANA BLP',
    tokenSymbol: MINTTOKEN.BANANA,
    icon: 'banana',
    stakeIcon: 'banana',
    otherName: 'BANANA'
  }
]

export const seascapeNftPools = [
  {
    pid: 400001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pCWS[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pCWS[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pCWS[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pCWS[ChainId.BSC_MAINNET]
    },
    name: 'CWS NFT Pool',
    symbol: 'pCWS',
    tokenSymbol: MINTTOKEN.SEASCAPENFT,
    icon: 'seascapenft',
    stakeIcon: 'seascapenft',
    otherName: 'SEASCAPE NFT'
  }
]

export const pCWSMasterPools = [
  {
    pid: 500001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to pCWS',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.PCWS,
    icon: 'pcws',
    stakeIcon: 'bake',
    otherName: 'pCWS'
  }
]

export const warMasterPools = [
  {
    pid: 600001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to WAR',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.WAR,
    icon: 'war',
    stakeIcon: 'bake',
    otherName: 'WAR'
  }
]

export const war2MasterPools = [
  {
    pid: 700001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.busdWarBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.busdWarBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.war[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.war[ChainId.BSC_MAINNET]
    },
    name: 'BUSD-WAR BLP',
    symbol: 'BUSD-WAR BLP',
    tokenSymbol: MINTTOKEN.WAR2,
    icon: 'war',
    stakeIcon: 'bake',
    otherName: 'WAR'
  }
]

export const tokocryptoNftPools = [
  {
    pid: 800001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'TKO NFT Pool',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.TKONFT,
    icon: 'tkonft',
    stakeIcon: 'bake',
    otherName: 'TKO NFT'
  }
]

export const dieselPools = [
  {
    pid: 900001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to DIESEL',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.DIESEL,
    icon: 'diesel',
    stakeIcon: 'bake',
    otherName: 'DIESEL'
  },
  {
    pid: 900002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bnbDieselBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bnbDieselBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.diesel[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.diesel[ChainId.BSC_MAINNET]
    },
    name: 'BNB-DIESEL BLP',
    symbol: 'BNB-DIESEL BLP',
    tokenSymbol: MINTTOKEN.DIESEL,
    icon: 'diesel',
    stakeIcon: 'bnb_diesel',
    otherName: 'DIESEL'
  }
]

export const mxMasterPools = [
  {
    pid: 1000001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to MX',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.MX,
    icon: 'mx',
    stakeIcon: 'bake',
    otherName: 'MX'
  }
]

export const aliceMasterPools = [
  {
    pid: 1100001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bakeAliceBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bakeAliceBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.alice[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.alice[ChainId.BSC_MAINNET]
    },
    name: 'BAKE-ALICE BLP',
    symbol: 'BAKE-ALICE BLP',
    tokenSymbol: MINTTOKEN.ALICE,
    icon: 'alice',
    stakeIcon: 'alicebake',
    otherName: 'ALICE'
  }
]

export const aliceNftPools = [
  {
    pid: 1200001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.alice[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.alice[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.alice[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.alice[ChainId.BSC_MAINNET]
    },
    name: 'ALICE NFT Pool',
    symbol: 'ALICE',
    tokenSymbol: MINTTOKEN.ALICENFT,
    icon: 'alice',
    stakeIcon: 'alice',
    otherName: 'ALICE NFT'
  }
]

export const dfyMasterPools = [
  {
    pid: 1300001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.dfyBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.dfyBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.dfy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.dfy[ChainId.BSC_MAINNET]
    },
    name: 'DFY-BNB to DFY',
    symbol: 'DFY-BNB BLP',
    tokenSymbol: MINTTOKEN.DFY,
    icon: 'dfy',
    stakeIcon: 'bnbDfy',
    otherName: 'DFY'
  },
  {
    pid: 1300002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.dfyBakeBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.dfyBakeBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.dfy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.dfy[ChainId.BSC_MAINNET]
    },
    name: 'DFY-BAKE to DFY',
    symbol: 'DFY-BAKE BLP',
    tokenSymbol: MINTTOKEN.DFY,
    icon: 'dfy',
    stakeIcon: 'bakeDfy',
    otherName: 'DFY'
  }
]

export const tctMasterPools = [
  {
    pid: 1400001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to TCT',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.TCT,
    icon: 'tct',
    stakeIcon: 'bake',
    otherName: 'TCT'
  }
]

export const gfxMasterPools = [
  {
    pid: 1500001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to GFX',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.GFX,
    icon: 'gfx',
    stakeIcon: 'bake',
    otherName: 'GFX'
  },
  {
    pid: 1500002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gfxBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gfxBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gfx[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gfx[ChainId.BSC_MAINNET]
    },
    name: 'GFX-BNB to GFX',
    symbol: 'GFX-BNB BLP',
    tokenSymbol: MINTTOKEN.GFX,
    icon: 'gfx',
    stakeIcon: 'bnb_gfx',
    otherName: 'GFX'
  }
]

export const xDittoMasterPools = [
  {
    pid: 1600001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to xDitto',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.XDITTO,
    icon: 'xditto',
    stakeIcon: 'bake',
    otherName: 'xDitto'
  }
]

export const sactMasterPools = [
  {
    pid: 1700001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sactBakeBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sactBakeBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sact[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sact[ChainId.BSC_MAINNET]
    },
    name: 'SACT-BAKE to SACT',
    symbol: 'SACT-BAKE BLP',
    tokenSymbol: MINTTOKEN.SACT,
    icon: 'sact',
    stakeIcon: 'sact_bake',
    otherName: 'SACT'
  }
]

export const pet3Pools = [
  {
    pid: 1800001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.petBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.petBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.pet[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.pet[ChainId.BSC_MAINNET]
    },
    name: 'EPET-BNB to PET',
    symbol: 'PET-BNB BLP',
    tokenSymbol: MINTTOKEN.PET3,
    icon: 'pet3',
    // activityTime: '5000 PET/hour from Oct. 20 07:00 UTC to Oct. 20 19:00 UTC',
    stakeIcon: 'bpet3',
    otherName: 'PET'
  }
]

export const hyfiPools = [
  {
    pid: 1900001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.hyfiBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.hyfiBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.hyfi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.hyfi[ChainId.BSC_MAINNET]
    },
    name: 'HYFI-BNB to HYFI',
    symbol: 'HYFI-BNB BLP',
    tokenSymbol: MINTTOKEN.HYFI,
    icon: 'hyfi',
    stakeIcon: 'bhyfi',
    otherName: 'HYFI'
  },
  {
    pid: 1900002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.hyfi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.hyfi[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to HYFI',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.HYFI,
    icon: 'hyfi',
    stakeIcon: 'bake',
    otherName: 'HYFI'
  }
]

export const tkoPools = [
  {
    pid: 2000001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tko[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tko[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to TKO',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.TKO,
    icon: 'tko',
    stakeIcon: 'bake',
    otherName: 'TKO'
  }
]

export const tkoNftPools = [
  {
    pid: 2100001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokocryptoNft[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokocryptoNft[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tko[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tko[ChainId.BSC_MAINNET]
    },
    name: 'TKO NFT to TKO',
    symbol: 'TKO NFT',
    tokenSymbol: MINTTOKEN.TKONFTSTAKE,
    icon: 'tkonft_earn',
    stakeIcon: 'tkonft_earn',
    otherName: 'TKO',
    stakeType: 1,
    amountDay: 300,
    amountUnit: 'TKO/Day'
  }
]

export const oneInchBakeNftPools = [
  {
    pid: 2200001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.oneInch[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.oneInch[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.oneInch[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.oneInch[ChainId.BSC_MAINNET]
    },
    name: '1INCH NFT Pool',
    symbol: '1INCH',
    tokenSymbol: MINTTOKEN.ONEINCHBAKENFT,
    icon: '1inch',
    stakeIcon: '1inch',
    otherName: '1INCH NFT'
  }
]

export const tko2Pools = [
  {
    pid: 2300001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tkoBusdBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tkoBusdBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tko[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tko[ChainId.BSC_MAINNET]
    },
    name: 'TKO-BUSD to TKO',
    symbol: 'TKO-BUSD BLP',
    tokenSymbol: MINTTOKEN.TKO2,
    icon: 'tko',
    stakeIcon: 'tko_busd',
    otherName: 'TKO'
  },
  {
    pid: 2300002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tkoBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tkoBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tko[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tko[ChainId.BSC_MAINNET]
    },
    name: 'TKO-BNB to TKO',
    symbol: 'TKO-BNB BLP',
    tokenSymbol: MINTTOKEN.TKO2,
    icon: 'tko',
    stakeIcon: 'tko_bnb',
    otherName: 'TKO'
  }
]

export const tlmPools = [
  {
    pid: 2400001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to TLM',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.TLM,
    icon: 'tlm',
    stakeIcon: 'bake',
    otherName: 'TLM',
    decimal: 4
  }
]

export const tsaPools = [
  {
    pid: 2500001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tsa[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tsa[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to TSA',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.TSA,
    icon: 'tsa',
    stakeIcon: 'bake',
    otherName: 'TSA'
  }
]

export const xdittoNftPools = [
  {
    pid: 2600001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.xDitto[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.xDitto[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.xDitto[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.xDitto[ChainId.BSC_MAINNET]
    },
    name: 'DITTO NFT Pool',
    symbol: 'XDITTO',
    tokenSymbol: MINTTOKEN.XDITTONFT,
    icon: 'ditto',
    stakeIcon: 'xditto',
    otherName: 'DITTO NFT'
  }
]

export const doggyTlmPools = [
  {
    pid: 2700001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.doggy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.doggy[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'DOGGY to TLM',
    symbol: 'DOGGY',
    tokenSymbol: MINTTOKEN.TLM2,
    icon: 'doggy',
    stakeIcon: 'doggy',
    otherName: 'TLM',
    decimal: 4
  }
]

export const bondlyPools = [
  {
    pid: 2700002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bondlyBnbBLp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bondlyBnbBLp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bondly[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bondly[ChainId.BSC_MAINNET]
    },
    name: 'BONDLY-BNB BLP',
    symbol: 'BONDLY-BNB BLP',
    tokenSymbol: MINTTOKEN.BONDLY,
    icon: 'bondly',
    stakeIcon: 'bnbbondly',
    otherName: 'BONDLY'
  }
]

export const bondly2Pools = [
  {
    pid: 2700003,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.doggy[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.doggy[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bondly[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bondly[ChainId.BSC_MAINNET]
    },
    name: 'DOGGY to BONDLY',
    symbol: 'DOGGY',
    tokenSymbol: MINTTOKEN.BONDLY2,
    icon: 'doggy',
    stakeIcon: 'doggy',
    otherName: 'BONDLY'
  }
]

export const ginuPools = [
  {
    pid: 2700004,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.ginuBnbBLp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.ginuBnbBLp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.ginu[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.ginu[ChainId.BSC_MAINNET]
    },
    name: 'GINU-BNB BLP',
    symbol: 'GINU-BNB BLP',
    tokenSymbol: MINTTOKEN.GINU,
    icon: 'ginu',
    stakeIcon: 'bnbginu',
    otherName: 'GINU'
  },
  {
    pid: 2700005,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.ginu[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.ginu[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.ginu[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.ginu[ChainId.BSC_MAINNET]
    },
    name: 'GINU to GINU',
    symbol: 'GINU',
    tokenSymbol: MINTTOKEN.GINU,
    icon: 'ginu',
    stakeIcon: 'ginu',
    otherName: 'GINU'
  }
]

export const barkTlmPools = [
  {
    pid: 2700006,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bark[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bark[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'BARK to TLM',
    symbol: 'BARK',
    tokenSymbol: MINTTOKEN.TLM3,
    icon: 'bark',
    stakeIcon: 'bark',
    otherName: 'TLM',
    decimal: 4
  }
]

export const bondlyNftPools = [
  {
    pid: 2700007,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bondly[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bondly[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bondly[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bondly[ChainId.BSC_MAINNET]
    },
    name: 'BONDLY NFT Pool',
    symbol: 'BONDLY',
    tokenSymbol: MINTTOKEN.BONDLYNFT,
    icon: 'bondly',
    stakeIcon: 'bondly',
    otherName: 'BONDLY NFT'
  }
]

export const tokauTlmPools = [
  {
    pid: 2700008,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokau[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokau[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'TOKAU to TLM',
    symbol: 'TOKAU',
    tokenSymbol: MINTTOKEN.TLM4,
    icon: 'tokau',
    stakeIcon: 'tokau',
    otherName: 'TLM',
    decimal: 4
  }
]

export const toyNftPools = [
  {
    pid: 2800001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.toys[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.toys[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gat[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gat[ChainId.BSC_MAINNET]
    },
    name: 'TOY NFT to GAT',
    symbol: 'TOY NFT',
    tokenSymbol: MINTTOKEN.TOYNFTSTAKE,
    icon: 'toynft_earn',
    stakeIcon: 'toynft_earn',
    otherName: 'GAT',
    stakeType: 1,
    amountDay: 1000,
    amountUnit: 'GAT/Day'
  }
]

export const levPools = [
  {
    pid: 2900001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.liBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.liBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.lev[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.lev[ChainId.BSC_MAINNET]
    },
    name: 'LI-BNB BLP',
    symbol: 'LI-BNB BLP',
    tokenSymbol: MINTTOKEN.LEV,
    icon: 'li',
    stakeIcon: 'bnbli',
    otherName: 'LEV'
  },
  {
    pid: 2900002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.siBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.siBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.lev[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.lev[ChainId.BSC_MAINNET]
    },
    name: 'SI-BNB BLP',
    symbol: 'SI-BNB BLP',
    tokenSymbol: MINTTOKEN.LEV,
    icon: 'si',
    stakeIcon: 'bnbsi',
    otherName: 'LEV'
  },
  {
    pid: 2900003,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.levBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.levBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.lev[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.lev[ChainId.BSC_MAINNET]
    },
    name: 'LEV-BNB BLP',
    symbol: 'LEV-BNB BLP',
    tokenSymbol: MINTTOKEN.LEV,
    icon: 'lev',
    stakeIcon: 'bnblev',
    otherName: 'LEV'
  }
]

export const gatTlmPools = [
  {
    pid: 2700009,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gat[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gat[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tlm[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tlm[ChainId.BSC_MAINNET]
    },
    name: 'GAT TO TLM',
    symbol: 'GAT',
    tokenSymbol: MINTTOKEN.TLM5,
    icon: 'gat',
    stakeIcon: 'gat',
    otherName: 'TLM',
    decimal: 4
  }
]

export const wsgPools = [
  {
    pid: 3000001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.wsg[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.wsg[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to WSG',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.WSG,
    icon: 'wsg',
    stakeIcon: 'bake',
    otherName: 'WSG'
  },
  {
    pid: 3000002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.wsgBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.wsgBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.wsg[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.wsg[ChainId.BSC_MAINNET]
    },
    name: 'WSG-BNB BLP',
    symbol: 'WSG-BNB BLP',
    tokenSymbol: MINTTOKEN.WSG,
    icon: 'wsg',
    stakeIcon: 'wsg_bnb',
    otherName: 'WSG'
  },
  {
    pid: 3000003,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gat[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gat[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.wsg[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.wsg[ChainId.BSC_MAINNET]
    },
    name: 'GAT to WSG',
    symbol: 'GAT',
    tokenSymbol: MINTTOKEN.WSG,
    icon: 'wsg',
    stakeIcon: 'gat',
    otherName: 'WSG'
  }
]

export const toynftEarnPools = [
  {
    pid: 3100001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gatBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gatBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.gatBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.gatBnbBlp[ChainId.BSC_MAINNET]
    },
    name: 'TOY NFT POOL',
    symbol: 'GAT-BNB BLP',
    tokenSymbol: MINTTOKEN.TOYNFT,
    icon: 'toynft',
    stakeIcon: 'gatBnb',
    otherName: 'TOY NFT'
  }
]

export const tokauPools = [
  {
    pid: 4000001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokau[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokau[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.tokau[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.tokau[ChainId.BSC_MAINNET]
    },
    name: 'TOKAU to TOKAU',
    symbol: 'TOKAU',
    tokenSymbol: MINTTOKEN.TOKAU,
    icon: 'tokau',
    stakeIcon: 'tokau',
    otherName: 'TOKAU'
  }
]

export const bakeMuskMixerNftPools = [
  {
    pid: 4100001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bakeMuskMixer[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bakeMuskMixer[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    name: 'BMM NFT to BAKE',
    symbol: 'Bake Musk Mixer NFT',
    tokenSymbol: MINTTOKEN.BMMNFTSTAKE,
    icon: 'tkonft_earn',
    stakeIcon: 'tkonft_earn',
    otherName: 'BAKE',
    stakeType: 1,
    // amountDay: 300,
    // amountUnit: 'TKO/Day'
  }
]

export const bnrgPools = [
  {
    pid: 4200001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bmonBusdBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bmonBusdBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.busd[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.busd[ChainId.BSC_MAINNET]
    },
    name: 'BMON-BUSD BLP',
    symbol: 'BMON-BUSD BLP',
    tokenSymbol: MINTTOKEN.BNRG,
    icon: 'bmon',
    stakeIcon: 'bmon_busd',
    otherName: 'BNRG'
  },
  {
    pid: 4200002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bmonBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bmonBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.weth[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.weth[ChainId.BSC_MAINNET]
    },
    name: 'BMON-BNB BLP',
    symbol: 'BMON-BNB BLP',
    tokenSymbol: MINTTOKEN.BNRG,
    icon: 'bmon',
    stakeIcon: 'bmon_bnb',
    otherName: 'BNRG'
  }
]


export const bmoncNftPools = [
  {
    pid: 4300001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bmonc[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bmonc[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.bmon[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.bmon[ChainId.BSC_MAINNET]
    },
    name: 'GENESIS NFT',
    symbol: 'GENESIS NFT',
    tokenSymbol: MINTTOKEN.BMONCNFTSTAKE,
    icon: 'bmoncnft_earn',
    stakeIcon: 'bmoncnft_earn',
    otherName: 'BMON',
    stakeType: 1,
    amountDay: 6000,
    amountUnit: 'BMON/Day'
  }
]

export const dogoPools = [
  {
    pid: 4400001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.dogo[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.dogo[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to DOGO',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.DOGO,
    icon: 'dogo',
    stakeIcon: 'bake',
    otherName: 'DOGO'
  }
]

export const eggPools = [
  {
    pid: 4500001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.egg[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.egg[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to EGG',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.EGG,
    icon: 'egg',
    stakeIcon: 'bake',
    otherName: 'EGG'
  }
]

export const kalataPools = [
  {
    pid: 4600001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.kalata[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.kalata[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to KALATA',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.KALATA,
    icon: 'kalata',
    stakeIcon: 'bake',
    otherName: 'KALATA'
  }
]

export const donPools = [
  {
    pid: 4700001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.don[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.don[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to DON',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.DON,
    icon: 'don',
    stakeIcon: 'bake',
    otherName: 'DON'
  }
]

export const ntPools = [
  {
    pid: 4800001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.nt[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.nt[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to NT',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.NT,
    icon: 'nt',
    stakeIcon: 'bake',
    otherName: 'NT'
  }
]

export const moniPools = [
  {
    pid: 4900001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.moni[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.moni[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to MONI',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.MONI,
    icon: 'moni',
    stakeIcon: 'bake',
    otherName: 'MONI'
  }
]

export const kxaPools = [
  {
    pid: 5000001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.kxa[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.kxa[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to KXA',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.KXA,
    icon: 'kxa',
    stakeIcon: 'bake',
    otherName: 'KXA'
  }
]

export const nblPools = [
  {
    pid: 5100001,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.sushi[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.sushi[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.nbl[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.nbl[ChainId.BSC_MAINNET]
    },
    name: 'BAKE to NBL',
    symbol: 'BAKE',
    tokenSymbol: MINTTOKEN.NBL,
    icon: 'nbl',
    stakeIcon: 'bake',
    otherName: 'NBL'
  },
  {
    pid: 5100002,
    lpAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.nblBnbBlp[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.nblBnbBlp[ChainId.BSC_MAINNET]
    },
    tokenAddresses: {
      [ChainId.BSC_TESTNET]: contractAddresses.nbl[ChainId.BSC_TESTNET],
      [ChainId.BSC_MAINNET]: contractAddresses.nbl[ChainId.BSC_MAINNET]
    },
    name: 'NBL-BNB BLP',
    symbol: 'NBL-BNB BLP',
    tokenSymbol: MINTTOKEN.NBL,
    icon: 'nbl',
    stakeIcon: 'nbl_bnb',
    otherName: 'NBL'
  }
]